// JoyDoc JSON data (templateOne, templateTwo, templateThree, templateFour)
export const data = {
  templateOne: {
    _id: '65f8965c2ae68615a7d2e6ec',
    type: 'template',
    stage: 'published',
    metadata: {},
    identifier: 'template_65f8965c2ae68615a7d2e6ec',
    name: 'Cleaning Checklist',
    createdOn: 1710795326855,
    files: [
      {
        _id: '65f8965c062ad113fb5433cc',
        metadata: {},
        name: 'Cleaning Checklist',
        version: 1,
        styles: {
          titleFontSize: 14,
          titleFontWeight: 'normal',
          fontSize: 14,
          fontColor: '',
          padding: 5,
          borderColor: ''
        },
        pages: [
          {
            name: 'New Page',
            fieldPositions: [
              {
                field: '65f8965cf921d46ee04b2a82',
                displayType: 'original',
                width: 15,
                height: 6,
                x: 0,
                y: 0,
                fontSize: 28,
                fontColor: '',
                fontWeight: 'bold',
                padding: 0,
                borderWidth: 0,
                _id: '65f89cfea5c24d74c69e5da0',
                type: 'block'
              },
              {
                field: '65f89dab707f4659709fb8c3',
                displayType: 'original',
                width: 6,
                height: 7,
                x: 18,
                y: 0,
                titleFontWeight: 'normal',
                textOverflow: '',
                _id: '65f89dc43c7cc5cb741a4694',
                type: 'text'
              },
              {
                field: '65f89e742d1ec71596193f63',
                displayType: 'original',
                width: 6,
                height: 7,
                x: 18,
                y: 8,
                format: 'MM/DD/YYYY hh:mma',
                _id: '65f89e7b7b0f80f04ce6bd5e',
                type: 'date'
              },
              {
                field: '65f8a973e1c4440a353f2183',
                displayType: 'original',
                width: 15,
                height: 9,
                x: 0,
                y: 6,
                fontSize: 12,
                fontColor: '#9cb1c8',
                fontStyle: 'normal',
                textTransform: 'none',
                textDecoration: 'none',
                padding: 5,
                borderWidth: 0,
                zIndex: 4,
                _id: '65f8a9e860892db8cc9f2e75',
                type: 'block'
              },
              {
                field: '65f98de9c7dffe8f455b1a02',
                displayType: 'original',
                width: 24,
                height: 2,
                x: 0,
                y: 15,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f98df7806b0f8709ba1421',
                type: 'block'
              },
              {
                field: '65f98e077e96709f30a61ad6',
                displayType: 'original',
                width: 6,
                height: 1,
                x: 18,
                y: 7,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f98e103e80d707c26c3a7f',
                type: 'block'
              },
              {
                field: '65f98e78a6d6c310beaede4b',
                displayType: 'original',
                width: 6,
                height: 7,
                x: 7,
                y: 17,
                _id: '65f98e7ccbe992dd3033c164',
                type: 'text'
              },
              {
                field: '65f98e88d9f4d486fa41c4b5',
                displayType: 'original',
                width: 6,
                height: 7,
                x: 0,
                y: 17,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f98e90c29d4adefb64e13e',
                type: 'dropdown'
              },
              {
                field: '65f98f49fea2bbe96d2cdfb0',
                displayType: 'original',
                width: 24,
                height: 2,
                x: 0,
                y: 24,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f98f7cb7b9e16cb1d3b4c1',
                type: 'block'
              },
              {
                field: '65f98f8a08a92befc5e738d3',
                displayType: 'original',
                width: 24,
                height: 59,
                x: 0,
                y: 34,
                targetValue: '65f896566ca14efaa2505172',
                titleDisplay: 'none',
                titleFontColor: '',
                fontColor: '',
                padding: 10,
                _id: '65f98f998e569a72c373910d',
                type: 'multiSelect'
              },
              {
                field: '65f98fd2db7d901537aadf4f',
                displayType: 'original',
                width: 7,
                height: 4,
                x: 0,
                y: 26,
                fontSize: 18,
                fontColor: '',
                fontWeight: 'bold',
                borderColor: '',
                borderWidth: 0,
                _id: '65f98fdb45ebefaceacfa2ef',
                type: 'block'
              },
              {
                field: '65f99044bc807d136a138625',
                displayType: 'original',
                width: 24,
                height: 4,
                x: 0,
                y: 30,
                fontSize: 12,
                fontColor: '#9cb1c8',
                borderColor: '',
                borderWidth: 0,
                _id: '65f990477036f9c0c6c13f0b',
                type: 'block'
              },
              {
                field: '65f9931e7e6426230ffcc2c5',
                displayType: 'original',
                width: 10,
                height: 11,
                x: 0,
                y: 139,
                _id: '65f99339fefd67532b681eec',
                type: 'signature'
              },
              {
                field: '65f9935a2e847399f9878944',
                displayType: 'original',
                width: 12,
                height: 9,
                x: 10,
                y: 139,
                fontSize: 12,
                fontColor: '#53a1f3',
                padding: 20,
                borderColor: '',
                borderWidth: 0,
                _id: '65f9935c04f3fb3ae05e53d8',
                type: 'block'
              },
              {
                field: '65f993b12466f95260000433',
                displayType: 'original',
                width: 24,
                height: 13,
                x: 0,
                y: 123,
                _id: '65f993b5206b5cb82b4cb774',
                type: 'textarea'
              },
              {
                field: '65f99416cf5430108bd127c7',
                displayType: 'original',
                width: 24,
                height: 3,
                x: 0,
                y: 120,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9941947ee278f01fbbe0a',
                type: 'block'
              },
              {
                field: '65f9943894aa8d8a4971c391',
                displayType: 'original',
                width: 24,
                height: 3,
                x: 0,
                y: 136,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9944282a7b1fe0178ad1b',
                type: 'block'
              },
              {
                field: '65f9ae8d5511c29777403456',
                displayType: 'original',
                width: 24,
                height: 24,
                x: 0,
                y: 96,
                columnTitleFontColor: '#64778c',
                columnTitlePadding: 10,
                titleFontColor: '#3a3a3a',
                titleFontWeight: 'bold',
                fontColor: '#98a7b6',
                _id: '65f9aea69f9f23c525df2510',
                type: 'table'
              },
              {
                field: '65f9b04c176582e779fd4246',
                displayType: 'original',
                width: 24,
                height: 3,
                x: 0,
                y: 93,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9b0502d67cfb6a10d7c8a',
                type: 'block'
              }
            ],
            metadata: {},
            hidden: false,
            width: 816,
            height: 1056,
            cols: 24,
            rowHeight: 8,
            layout: 'grid',
            presentation: 'normal',
            margin: 0,
            padding: 30,
            borderWidth: 0,
            _id: '65f8965c5b0ccbe9ba08d20a'
          }
        ],
        pageOrder: ['65f8965c5b0ccbe9ba08d20a'],
        views: []
      }
    ],
    fields: [
      {
        type: 'block',
        _id: '65f8965cf921d46ee04b2a82',
        identifier: 'field_65f89cfeaea3616939baba1e',
        title: 'Heading Text',
        description: '',
        value: 'Hotel Room Cleaning Checklist',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'text',
        _id: '65f89dab707f4659709fb8c3',
        identifier: 'field_65f89dc4fb1fac9bdd36ee7a',
        title: "Cleaner's Name",
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'date',
        _id: '65f89e742d1ec71596193f63',
        identifier: 'field_65f89e7b7518afa20f6f7be1',
        title: 'Date',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f8a973e1c4440a353f2183',
        identifier: 'field_65f8a9e8be75936fbc08b668',
        title: 'Display Text',
        description: '',
        value:
          'A hotel cleaning checklist form ensures that all necessary tasks for maintaining cleanliness and hygiene in guest rooms and common areas are completed systematically and consistently.',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f98de9c7dffe8f455b1a02',
        identifier: 'field_65f98df741c40f4805334eec',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f98e077e96709f30a61ad6',
        identifier: 'field_65f98e10bc696ebfab6da6ab',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'text',
        _id: '65f98e78a6d6c310beaede4b',
        identifier: 'field_65f98e7c86ec6bc036d3512a',
        title: 'Room#',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'dropdown',
        _id: '65f98e88d9f4d486fa41c4b5',
        identifier: 'field_65f98e90458789403a9c0364',
        title: 'Floor',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: '1', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: '2', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: '3', deleted: false },
          {
            _id: '65f98ea82cbbe889da036391',
            value: '4',
            width: 200,
            deleted: false
          }
        ],
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f98f49fea2bbe96d2cdfb0',
        identifier: 'field_65f98f7c311ca3070be4c0c0',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'multiSelect',
        _id: '65f98f8a08a92befc5e738d3',
        identifier: 'field_65f98f998cfef567e7089936',
        title: 'Multiple Choice',
        description: '',
        value: [],
        required: true,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          {
            _id: '65f896566ca14efaa2505172',
            value: 'Is the entry door clean?',
            deleted: false
          },
          {
            _id: '65f89656d9a7f351230da533',
            value: 'Is the hardware clean?',
            deleted: false
          },
          {
            _id: '65f896567ff076cd276ac74f',
            value: 'Are walls clean in the bed room area?',
            deleted: false
          },
          {
            _id: '65f991be411353f8f64a4932',
            value: 'Has the room been edged?',
            width: 200,
            deleted: true
          },
          {
            _id: '65f9920da0fd23c6f5f3a816',
            value: 'Is the microwave clean?',
            width: 100,
            deleted: true
          },
          {
            _id: '65f99217566981e14acd35d1',
            value: 'Is the mini fridge clean?',
            width: 100,
            deleted: true
          },
          {
            _id: '65f992213309151ade3dfb8a',
            value: 'Is the television clean?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9922d8fd34bd08cd3b1e8',
            value: 'Is the remote clean and working?',
            width: 100,
            deleted: true
          },
          {
            _id: '65f9923af7c0a7d72593f15c',
            value: 'Is the mirror clean?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f99242473827b0957befe3',
            value: 'Are the headboards clean?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9924ae9e3428db98cb1af',
            value: 'Is the bed properly made up and look clean?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f992585a79db8e5344ad4f',
            value: 'Is all room collateral clean and in good condition?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f992786ff8b2ecffbd8a91',
            value: 'Are the trash cans clean with a liner?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9927f19368ce0f8370685',
            value: 'Has all high dusting been completed?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9928b6656cb1d47332dcf',
            value: 'Has the carpet been vacuumed?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f992975db5cc5ed88c5b63',
            value: 'Is the furniture clean and free from scratches?',
            width: 100,
            deleted: false
          },
          {
            _id: '65f992ad2ca7cddb9fb1dcf0',
            value: 'Is the bathroom clean and free from hair?',
            width: 100,
            deleted: false
          }
        ],
        multi: true,
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f98fd2db7d901537aadf4f',
        identifier: 'field_65f98fdbe9d8fd5c6f9fe229',
        title: 'Display Text',
        description: '',
        value: 'Cleaning Checklist',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f99044bc807d136a138625',
        identifier: 'field_65f99047903168c25216415f',
        title: 'Display Text',
        description: '',
        value:
          'Check all that applies. All items must be checked before completing this job.',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'signature',
        _id: '65f9931e7e6426230ffcc2c5',
        identifier: 'field_65f9933938a92d100742f655',
        title: "Cleaner's Signature",
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f9935a2e847399f9878944',
        identifier: 'field_65f9935cc4e85218bad39d27',
        title: 'Display Text',
        description: '',
        value:
          'Please sign to confirm that you have provided all necessary information before submitting the form.',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'textarea',
        _id: '65f993b12466f95260000433',
        identifier: 'field_65f993b58a46cd24ade65440',
        title: 'Comments',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f99416cf5430108bd127c7',
        identifier: 'field_65f99419dcf91c7cd55f35e2',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f9943894aa8d8a4971c391',
        identifier: 'field_65f99442b9871e0113f8abec',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'table',
        _id: '65f9ae8d5511c29777403456',
        identifier: 'field_65f9aea689de182dc0372ecb',
        title: 'Are there any damages?',
        description: '',
        value: [
          { _id: '65f896568448c73b539c9d2a', deleted: false, cells: {} },
          { _id: '65f89656ca32090d6011179f', deleted: false, cells: {} },
          { _id: '65f89656befb0fa64f1d5a8a', deleted: false, cells: {} }
        ],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        rowOrder: [
          '65f896568448c73b539c9d2a',
          '65f89656ca32090d6011179f',
          '65f89656befb0fa64f1d5a8a'
        ],
        tableColumns: [
          {
            _id: '65f896566ec9a6a07b4e6dad',
            type: 'text',
            title: 'Damaged Item',
            width: 0,
            identifier: 'field_column_65f9aea6000d427a89b1f91b'
          },
          {
            _id: '65f9af050f9c0d427b63720c',
            type: 'image',
            title: 'Upload Image(s)',
            width: 0,
            identifier: '',
            maxImageWidth: 100,
            maxImageHeight: 100
          },
          {
            _id: '65f9afe9b1786e1451fa7708',
            type: 'dropdown',
            title: 'Condition',
            width: 0,
            identifier: '',
            options: [
              { _id: '65f9afe91142c34ab4366860', value: 'Ok', deleted: false },
              {
                _id: '65f9afe914d39f586e6d970a',
                value: 'Poor',
                deleted: false
              },
              {
                _id: '65f9afe9ca4a85c97a3bd805',
                value: 'Needs Replaced',
                deleted: false
              }
            ]
          }
        ],
        tableColumnOrder: [
          '65f896566ec9a6a07b4e6dad',
          '65f9afe9b1786e1451fa7708',
          '65f9af050f9c0d427b63720c'
        ],
        file: '65f8965c062ad113fb5433cc'
      },
      {
        type: 'block',
        _id: '65f9b04c176582e779fd4246',
        identifier: 'field_65f9b050669adc4de6169da8',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f8965c062ad113fb5433cc'
      }
    ],
    deleted: false,
    categories: []
  },
  templateTwo: {
    _id: '65f99fa2930179130fee34be',
    type: 'template',
    stage: 'published',
    metadata: {},
    identifier: 'template_65f99fa2930179130fee34be',
    name: 'Intake Form',
    createdOn: 1710858264336,
    files: [
      {
        _id: '65f99fa2f0fbdc2824e345d8',
        metadata: {},
        name: 'Intake Form',
        version: 1,
        styles: {
          titleFontSize: 14,
          titleFontColor: '',
          fontSize: 14,
          fontColor: ''
        },
        pages: [
          {
            name: 'New Page',
            fieldPositions: [
              {
                field: '65f9a018e6ef8749dfe34abd',
                displayType: 'original',
                width: 8,
                height: 16,
                x: 8,
                y: 0,
                titleDisplay: 'none',
                borderColor: '',
                borderWidth: 0,
                _id: '65f9a02204b2e6dcc17cdb56',
                type: 'image'
              },
              {
                field: '65f9a1ec34bd22cbcb2519e4',
                displayType: 'original',
                width: 24,
                height: 5,
                x: 0,
                y: 17,
                fontSize: 28,
                fontWeight: 'bold',
                textAlign: 'center',
                _id: '65f9a20a8b8e9e782555d90d',
                type: 'block'
              },
              {
                field: '65f9a20ae4ef35554cd49426',
                displayType: 'original',
                width: 24,
                height: 1,
                x: 0,
                y: 16,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a2110ddefa69ccef57c8',
                type: 'block'
              },
              {
                field: '65f9a267fb701d539142671d',
                displayType: 'original',
                width: 20,
                height: 5,
                x: 2,
                y: 22,
                _id: '65f9a27898f6bcc600c09ef3',
                type: 'block'
              },
              {
                field: '65f9a2999287a53ba8853f8e',
                displayType: 'original',
                width: 20,
                height: 4,
                x: 2,
                y: 30,
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'center',
                backgroundColor: '#58b389',
                _id: '65f9a2aaab2f4a57fdded1cb',
                type: 'block'
              },
              {
                field: '65f9a2aa5d0d1660db64193d',
                displayType: 'original',
                width: 24,
                height: 3,
                x: 0,
                y: 27,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a2abbd141ad7ebcb6104',
                type: 'block'
              },
              {
                field: '65f9a300d188976c0de9582f',
                displayType: 'original',
                width: 7,
                height: 33,
                x: 15,
                y: 36,
                titleTextAlign: 'center',
                _id: '65f9a319972b7ee95bf92e82',
                type: 'image'
              },
              {
                field: '65f9a32e61fd3e92a35237e8',
                displayType: 'original',
                width: 20,
                height: 2,
                x: 2,
                y: 34,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a3328ba778af4c077af0',
                type: 'block'
              },
              {
                field: '65f9a357f4824cb48d29bb16',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 2,
                y: 36,
                _id: '65f9a35d8565c7a4f27d65d9',
                type: 'text'
              },
              {
                field: '65f9a3675b9494b0a91d166b',
                displayType: 'horizontal',
                width: 11,
                height: 8,
                x: 2,
                y: 43,
                targetValue: '65f89656c2339b75015a9349',
                fontColor: '#95aaa2',
                _id: '65f9a3729126f0d1c04ca10a',
                type: 'multiSelect'
              },
              {
                field: '65f9a392921dde21c715dfd9',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 2,
                y: 51,
                _id: '65f9a3d76a581dfe2b0237e2',
                type: 'text'
              },
              {
                field: '65f9a458157fd17626d6a655',
                displayType: 'original',
                width: 5,
                height: 7,
                x: 2,
                y: 58,
                _id: '65f9a460bc528e572e676e05',
                type: 'text'
              },
              {
                field: '65f9a46a72e23f08c36d4ffa',
                displayType: 'original',
                width: 2,
                height: 7,
                x: 7,
                y: 58,
                _id: '65f9a46d059143d6a6608ce6',
                type: 'text'
              },
              {
                field: '65f9a473ec0be10589f37806',
                displayType: 'original',
                width: 4,
                height: 7,
                x: 9,
                y: 58,
                _id: '65f9a476a106794f5fb562e3',
                type: 'text'
              },
              {
                field: '65f9a4c2936f632839ad97a6',
                displayType: 'original',
                width: 6,
                height: 7,
                x: 2,
                y: 65,
                _id: '65f9a4d50ab0bdb6a873491c',
                type: 'text'
              },
              {
                field: '65f9a4dc5228680a29201761',
                displayType: 'original',
                width: 5,
                height: 7,
                x: 8,
                y: 65,
                _id: '65f9a4de25f58ff7595671aa',
                type: 'number'
              },
              {
                field: '65f9a5130702507cc0bcf087',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 72,
                borderWidth: 1,
                backgroundColor: '',
                _id: '65f9a51bec6fe5384e559eec',
                type: 'text'
              },
              {
                field: '65f9a547763efe5ecfc0f1b0',
                displayType: 'original',
                width: 20,
                height: 4,
                x: 2,
                y: 79,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a567f373e9e8b3558440',
                type: 'block'
              },
              {
                field: '65f9a56cb77b7fae44b86b92',
                displayType: 'original',
                width: 20,
                height: 4,
                x: 2,
                y: 83,
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'center',
                backgroundColor: '#58b389',
                _id: '65f9a571232531decb971dab',
                type: 'block'
              },
              {
                field: '65f9a5d938a014904ea81145',
                displayType: 'original',
                width: 20,
                height: 2,
                x: 2,
                y: 87,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a66cf840c9b47bb8b6ee',
                type: 'block'
              },
              {
                field: '65f9a67d933e00773c8cc1f3',
                displayType: 'original',
                width: 20,
                height: 9,
                x: 2,
                y: 89,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a67e465b32c36479e8b1',
                type: 'dropdown'
              },
              {
                field: '65f9a70fb9863119afed58a4',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 98,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a7110bd97a76cbc6f285',
                type: 'dropdown'
              },
              {
                field: '65f9a71f778ef9d9b02b2f56',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 105,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a724f6cfeeca899d0931',
                type: 'dropdown'
              },
              {
                field: '65f9a731682c2c7d7ab5bd33',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 112,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a736f4641b1f8bdb83a2',
                type: 'dropdown'
              },
              {
                field: '65f9a74080e9e5bf7a7e8dd0',
                displayType: 'original',
                width: 20,
                height: 9,
                x: 2,
                y: 119,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a74651e349c63e0fa511',
                type: 'dropdown'
              },
              {
                field: '65f9a769cdd1ca02bf219649',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 128,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a76b7abfe07a637c39e8',
                type: 'dropdown'
              },
              {
                field: '65f9a782923149a12eae7e56',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 2,
                y: 135,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a7852afd445a1f414540',
                type: 'dropdown'
              },
              {
                field: '65f9a796da17cefb80836450',
                displayType: 'original',
                width: 9,
                height: 7,
                x: 13,
                y: 135,
                _id: '65f9a79731372160b962fee6',
                type: 'text'
              },
              {
                field: '65f9a7abab601dea8dc09253',
                displayType: 'original',
                width: 20,
                height: 7,
                x: 2,
                y: 142,
                targetValue: '65f89656bc8785b1155e649a',
                _id: '65f9a7b4f357a9c078fe8fac',
                type: 'dropdown'
              },
              {
                field: '65f9a7ca42284660f55f0f90',
                displayType: 'original',
                width: 20,
                height: 26,
                x: 2,
                y: 149,
                backgroundColor: '',
                _id: '65f9a7cb39d73150d3bf6aec',
                type: 'textarea'
              }
            ],
            metadata: {},
            hidden: false,
            width: 816,
            height: 1056,
            cols: 24,
            rowHeight: 8,
            layout: 'grid',
            presentation: 'normal',
            margin: 0,
            padding: 20,
            borderWidth: 0,
            _id: '65f99fa22e12b9324bf64131'
          },
          {
            name: 'New Page',
            fieldPositions: [
              {
                field: '65f9a828b7474630a9b95c4a',
                displayType: 'original',
                width: 20,
                height: 4,
                x: 2,
                y: 0,
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'center',
                backgroundColor: '#58b389',
                _id: '65f9a82c896527912d00ed11',
                type: 'block'
              },
              {
                field: '65f9a8536b2653f9c44ea0a0',
                displayType: 'horizontal',
                width: 20,
                height: 10,
                x: 2,
                y: 6,
                targetValue: '65f89656c2339b75015a9349',
                _id: '65f9a855d4bbce93dc5c0455',
                type: 'multiSelect'
              },
              {
                field: '65f9a8550e925626786e5d3d',
                displayType: 'original',
                width: 20,
                height: 2,
                x: 2,
                y: 4,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9a8599ea42fc9165a817d',
                type: 'block'
              },
              {
                field: '65f9a8a6941b7259e870474b',
                displayType: 'horizontal',
                width: 20,
                height: 11,
                x: 2,
                y: 16,
                targetValue: '65f89656c2339b75015a9349',
                _id: '65f9a8ac0e7fff3193b20519',
                type: 'multiSelect'
              },
              {
                field: '65f9a978cee7dcae94f26015',
                displayType: 'original',
                width: 7,
                height: 11,
                x: 2,
                y: 27,
                targetValue: '65f89656c2339b75015a9349',
                borderWidth: 0,
                _id: '65f9a97d133b7c1917753371',
                type: 'multiSelect'
              },
              {
                field: '65f9a992ddc330b985f6ba01',
                displayType: 'original',
                width: 13,
                height: 10,
                x: 9,
                y: 27,
                _id: '65f9a994e7db609781cc3563',
                type: 'textarea'
              },
              {
                field: '65f9aa45d9314886b819e312',
                displayType: 'original',
                width: 20,
                height: 4,
                x: 2,
                y: 41,
                fontWeight: 'bold',
                textAlign: 'center',
                backgroundColor: '#58b389',
                _id: '65f9aa5941da78757490d655',
                type: 'block'
              },
              {
                field: '65f9aa6353289702cc8d7dd2',
                displayType: 'original',
                width: 20,
                height: 3,
                x: 2,
                y: 38,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9aa669b39def5ef43de9a',
                type: 'block'
              },
              {
                field: '65f9ab028b2cca59b932b8e9',
                displayType: 'original',
                width: 14,
                height: 7,
                x: 5,
                y: 108,
                titleDisplay: 'none',
                borderWidth: 0,
                _id: '65f9ab09f202bc9eedecfbf6',
                type: 'image'
              },
              {
                field: '65f9ab23e2c0b1d0647b8413',
                displayType: 'original',
                width: 21,
                height: 46,
                x: 2,
                y: 62,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9ab26e792be40a54a2aa8',
                type: 'block'
              },
              {
                field: '65f9ab2d9558546636ec83ef',
                displayType: 'original',
                width: 12,
                height: 14,
                x: 2,
                y: 48,
                _id: '65f9ab47307dddd485d90460',
                type: 'signature'
              },
              {
                field: '65f9ab4dfe6c84c2efd4273d',
                displayType: 'original',
                width: 20,
                height: 3,
                x: 2,
                y: 45,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '65f9ab4faa5ab1df3d7add93',
                type: 'block'
              },
              {
                field: '65f9ab5c13750278538479d9',
                displayType: 'original',
                width: 7,
                height: 7,
                x: 15,
                y: 48,
                format: 'MM/DD/YYYY hh:mma',
                _id: '65f9ab6114bd6889b823fab6',
                type: 'date'
              },
              {
                field: '65f9ab692d08eecc3f8a11a5',
                displayType: 'original',
                width: 7,
                height: 7,
                x: 15,
                y: 55,
                _id: '65f9ab6bd6a29b3f1b30d656',
                type: 'text'
              }
            ],
            metadata: {},
            hidden: false,
            width: 816,
            height: 1056,
            cols: 24,
            rowHeight: 8,
            layout: 'grid',
            presentation: 'normal',
            margin: 0,
            padding: 20,
            borderWidth: 0,
            _id: '65f9a81344b7350fbcce0945'
          }
        ],
        pageOrder: ['65f99fa22e12b9324bf64131', '65f9a81344b7350fbcce0945'],
        views: []
      }
    ],
    fields: [
      {
        type: 'image',
        _id: '65f9a018e6ef8749dfe34abd',
        identifier: 'field_65f9a022a967a6977acda760',
        title: 'Image',
        description: '',
        value: [
          {
            _id: '65f9a1b56a687c80a13e3a57',
            url: 'https://s3.amazonaws.com/docspace.production.documents/6516f019acf016f22d0ba15d/documents/template_65f99fa2930179130fee34be/65f9a1b423fcca7e3367d105-1710858676996.png',
            fileName: '65f9a1b423fcca7e3367d105-1710858676996.png',
            filePath:
              '6516f019acf016f22d0ba15d/documents/template_65f99fa2930179130fee34be'
          }
        ],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a1ec34bd22cbcb2519e4',
        identifier: 'field_65f9a20a13d523dd4e4d4fe9',
        title: 'Heading Text',
        description: '',
        value: 'INTAKE FORM',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a20ae4ef35554cd49426',
        identifier: 'field_65f9a2117fee5b58f00b5d87',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a267fb701d539142671d',
        identifier: 'field_65f9a278453797809a54dbc0',
        title: 'Display Text',
        description: '',
        value:
          'Disclaimer: Thank you for your interest in being our client. Information collected about new clients is confidential and will be treated accordingly.',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a2999287a53ba8853f8e',
        identifier: 'field_65f9a2aaa54a300c4015e7fa',
        title: 'Display Text',
        description: '',
        value: 'Client Information',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a2aa5d0d1660db64193d',
        identifier: 'field_65f9a2ab9a6bfcba0118848e',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'image',
        _id: '65f9a300d188976c0de9582f',
        identifier: 'field_65f9a319cbb28ad06aa7d16d',
        title: 'Client Photo',
        description: '',
        value: [],
        required: false,
        tipTitle: 'Photo Instructions',
        tipDescription:
          "Upload a current photo of you or your driver's license.",
        tipVisible: true,
        metadata: {},
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a32e61fd3e92a35237e8',
        identifier: 'field_65f9a332f7ac15af21b3a029',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a357f4824cb48d29bb16',
        identifier: 'field_65f9a35dc0b9f5a8527b3012',
        title: 'Name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'multiSelect',
        _id: '65f9a3675b9494b0a91d166b',
        identifier: 'field_65f9a3723943b467722fed6b',
        title: 'Gender',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656c2339b75015a9349', value: 'Male', deleted: false },
          { _id: '65f89656e5655a5330c6aea6', value: 'Female', deleted: false },
          { _id: '65f8965684ff8b02d1b49619', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a392921dde21c715dfd9',
        identifier: 'field_65f9a3d7525c6d49c0207ad3',
        title: 'Address',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a458157fd17626d6a655',
        identifier: 'field_65f9a460f7f1e6350e422a65',
        title: 'City',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a46a72e23f08c36d4ffa',
        identifier: 'field_65f9a46decedaaa6216e4bd0',
        title: 'State',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a473ec0be10589f37806',
        identifier: 'field_65f9a4768750c9b4d8580bd0',
        title: 'Postal Code',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a4c2936f632839ad97a6',
        identifier: 'field_65f9a4d552d3bea5a218ce9d',
        title: 'Email',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'number',
        _id: '65f9a4dc5228680a29201761',
        identifier: 'field_65f9a4de5c856a0fbc3b7683',
        title: 'Phone #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a5130702507cc0bcf087',
        identifier: 'field_65f9a51bd1e297fdeeeff95a',
        title: 'How did you hear about us?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a547763efe5ecfc0f1b0',
        identifier: 'field_65f9a56703a4b097d1644eee',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a56cb77b7fae44b86b92',
        identifier: 'field_65f9a5712edc4a1958b30ee8',
        title: 'Display Text',
        description: '',
        value: 'Health / Par-Q Form',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a5d938a014904ea81145',
        identifier: 'field_65f9a66cf383093de57d7756',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a67d933e00773c8cc1f3',
        identifier: 'field_65f9a67e513d063b10d3a4be',
        title:
          'Has your doctor ever said that you have a heart condition and should only do physical activity recommended by a doctor?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a70fb9863119afed58a4',
        identifier: 'field_65f9a711c2ab27d322fe81eb',
        title: 'Do you feel pain in your chest when you do physical activity?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a71f778ef9d9b02b2f56',
        identifier: 'field_65f9a7245ae491c33801ce88',
        title:
          'In the past month, have you had chest pain when you were not doing physical activity?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a731682c2c7d7ab5bd33',
        identifier: 'field_65f9a736ad26a831b978051a',
        title:
          'Do you lose balance because of dizziness or do you ever lose consciousness?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a74080e9e5bf7a7e8dd0',
        identifier: 'field_65f9a746cdfc3e63c35ac9d5',
        title:
          'Do you have a bone, joint, or other health problem that causes you pain or limitations in movement?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a769cdd1ca02bf219649',
        identifier: 'field_65f9a76b1d6f8c8d8999366c',
        title:
          'Are you pregnant now or have given birth within the last six months?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a782923149a12eae7e56',
        identifier: 'field_65f9a785616bb4ea58cbc098',
        title: 'Do you take any medications on a regular basis?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9a796da17cefb80836450',
        identifier: 'field_65f9a797d316cd4aae2becac',
        title: 'If so, what are the medications?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'dropdown',
        _id: '65f9a7abab601dea8dc09253',
        identifier: 'field_65f9a7b47cbf20d34ebe77fa',
        title:
          'Do you know of any other reason why you should not do physical activity?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656bc8785b1155e649a', value: 'Yes', deleted: false },
          { _id: '65f89656b5eb282188804f94', value: 'No', deleted: false },
          { _id: '65f89656e6c1cfab52c05400', value: 'N/A', deleted: false }
        ],
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'textarea',
        _id: '65f9a7ca42284660f55f0f90',
        identifier: 'field_65f9a7cbf52fd247cec956f2',
        title:
          'If you marked “Yes” to any of the above, please explain in detail below: ',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a828b7474630a9b95c4a',
        identifier: 'field_65f9a82c3e01aa2a34e28aa8',
        title: 'Display Text',
        description: '',
        value: 'Membership',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'multiSelect',
        _id: '65f9a8536b2653f9c44ea0a0',
        identifier: 'field_65f9a8552988ffb00c9f4ae4',
        title: 'Please indicate the type of membership you require:',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656c2339b75015a9349', value: 'Adult', deleted: false },
          { _id: '65f89656e5655a5330c6aea6', value: 'Student', deleted: false },
          {
            _id: '65f8965684ff8b02d1b49619',
            value: 'Disability',
            deleted: false
          },
          {
            _id: '65f9a87462d486c0bb56aad7',
            value: 'Retired',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9a878c0a3002768a7012f',
            value: 'Family',
            width: 100,
            deleted: false
          },
          {
            _id: '65f9a88035e0b36b13740a0f',
            value: 'Couple',
            width: 100,
            deleted: false
          }
        ],
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9a8550e925626786e5d3d',
        identifier: 'field_65f9a85912c535ccf1477020',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'multiSelect',
        _id: '65f9a8a6941b7259e870474b',
        identifier: 'field_65f9a8acf479b3b1f31e87d1',
        title: 'Membership duration:',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656c2339b75015a9349', value: '1 Year', deleted: false },
          {
            _id: '65f89656e5655a5330c6aea6',
            value: '6 Months',
            deleted: false
          },
          {
            _id: '65f8965684ff8b02d1b49619',
            value: '3 Months',
            deleted: false
          },
          {
            _id: '65f9a8cef3166fd42bef7dc7',
            value: '1 Month',
            width: 125,
            deleted: false
          },
          {
            _id: '65f9a8e61339281f2b8df93a',
            value: 'Day-by-day',
            width: 125,
            deleted: false
          }
        ],
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'multiSelect',
        _id: '65f9a978cee7dcae94f26015',
        identifier: 'field_65f9a97d983fc3ce2ed640d2',
        title: 'Are you interested in personal training or classes?',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65f89656c2339b75015a9349', value: 'Yes', deleted: false },
          { _id: '65f89656e5655a5330c6aea6', value: 'No', deleted: false },
          { _id: '65f8965684ff8b02d1b49619', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'textarea',
        _id: '65f9a992ddc330b985f6ba01',
        identifier: 'field_65f9a9941747e3fa4aadbf10',
        title: 'If yes, please specify:\n',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9aa45d9314886b819e312',
        identifier: 'field_65f9aa5921e63eee558d96d9',
        title: 'Display Text',
        description: '',
        value: 'Client Signature',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9aa6353289702cc8d7dd2',
        identifier: 'field_65f9aa6628a62ee3bfb0ad45',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'image',
        _id: '65f9ab028b2cca59b932b8e9',
        identifier: 'field_65f9ab09b241d97d0dd1e7d8',
        title: 'Image',
        description: '',
        value: [
          {
            _id: '65f9ab1877b2dff1872947e3',
            url: 'https://s3.amazonaws.com/docspace.production.documents/6516f019acf016f22d0ba15d/documents/template_65f99fa2930179130fee34be/65f9ab188b3261b2ef293944-1710861080521.png',
            fileName: '65f9ab188b3261b2ef293944-1710861080521.png',
            filePath:
              '6516f019acf016f22d0ba15d/documents/template_65f99fa2930179130fee34be'
          }
        ],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        multi: false,
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9ab23e2c0b1d0647b8413',
        identifier: 'field_65f9ab26ed911957094b9af3',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'signature',
        _id: '65f9ab2d9558546636ec83ef',
        identifier: 'field_65f9ab47eb1d7c3c358b74c7',
        title: 'Signature',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'block',
        _id: '65f9ab4dfe6c84c2efd4273d',
        identifier: 'field_65f9ab4f8d39163d7d5cd2f4',
        title: 'Empty Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'date',
        _id: '65f9ab5c13750278538479d9',
        identifier: 'field_65f9ab6147a61a7071c44864',
        title: 'Date',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      },
      {
        type: 'text',
        _id: '65f9ab692d08eecc3f8a11a5',
        identifier: 'field_65f9ab6b854aa9287bd2f97f',
        title: 'Print Name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65f99fa2f0fbdc2824e345d8'
      }
    ],
    deleted: false,
    categories: []
  },
  templateThree: {
    _id: '64be9a828a5e09e48d7f63af',
    type: 'template',
    stage: 'published',
    metadata: {},
    identifier: 'doc_64be9a828a5e09e48d7f63af',
    name: 'Fire Pump Graph Form',
    createdOn: 1690213012082,
    files: [
      {
        _id: '64be9a826eefbc6b2dda0222',
        metadata: {},
        name: 'Fire Pump Graph Form',
        version: 1,
        styles: {},
        pages: [
          {
            name: 'New Page',
            fieldPositions: [
              {
                field: '64be9aa9e38e1896e552bb08',
                displayType: 'original',
                width: 16,
                height: 10,
                x: 4,
                y: 13,
                _id: '64be9aaa44486e50d401ba63',
                type: 'richText'
              },
              {
                field: '64be9b545c0f26572f6a8665',
                displayType: 'original',
                width: 5,
                height: 13,
                x: 10,
                y: 0,
                titleDisplay: 'none',
                _id: '64be9b55afd2e4674032159d',
                type: 'image'
              },
              {
                field: '64be9b9781d215b4c7fa17e9',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 23,
                _id: '64be9b98c8d35889265eb5e4',
                type: 'text'
              },
              {
                field: '64be9bc3c9d0b84b0dd3c4cc',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 30,
                _id: '64be9bc50c20a126cbd893fd',
                type: 'text'
              },
              {
                field: '64be9be7a9d3edfcd976c070',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 23,
                _id: '64be9be9c95b634cbd7b43b7',
                type: 'date'
              },
              {
                field: '64be9c131ab8450032a93a9b',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 37,
                _id: '64be9c152c4ff9e8f435cfaa',
                type: 'text'
              },
              {
                field: '64be9c2efa51d0110f7d1dcf',
                displayType: 'original',
                width: 5,
                height: 7,
                x: 1,
                y: 37,
                _id: '64be9c30ca6dd1057cd92829',
                type: 'text'
              },
              {
                field: '64be9c7aedaa69114f5ce19f',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 30,
                targetValue: '64be6c9328bd20c6bb432d43',
                _id: '64be9c7c0b82872f19e13c2e',
                type: 'dropdown'
              },
              {
                field: '64be9cf2837587e242fa2b0d',
                displayType: 'original',
                width: 5.88,
                height: 7,
                x: 6,
                y: 37,
                _id: '64be9cf5857495559389d428',
                type: 'text'
              },
              {
                field: '64be9dcc1bd8af33b28ac04e',
                displayType: 'original',
                width: 22,
                height: 6,
                x: 1,
                y: 50,
                _id: '64be9dcfed5b12bd042782ed',
                type: 'richText'
              },
              {
                field: '64be9df3d7e3ac0c46b4fc1f',
                displayType: 'original',
                width: 22,
                height: 1,
                x: 1,
                y: 47,
                borderColor: 'transparent',
                backgroundColor: '#f28b8b',
                _id: '64be9df5529dd45d1902c0b7',
                type: 'block'
              },
              {
                field: '64be9e4c7c75340370ca6322',
                displayType: 'original',
                width: 22,
                height: 3,
                x: 1,
                y: 44,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '64be9e4d8e215ed5c5135331',
                type: 'block'
              },
              {
                field: '64be9e55adce2d0137109ab6',
                displayType: 'original',
                width: 22,
                height: 2,
                x: 1,
                y: 48,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '64be9e575139fc755cbba629',
                type: 'block'
              },
              {
                field: '64be9e863a3c0c809386b55b',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 56,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9e88e9b62b2e1f5a2f60',
                type: 'dropdown'
              },
              {
                field: '64be9e9e9484742a7569ca16',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 56,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9ea018f4b21938e77110',
                type: 'dropdown'
              },
              {
                field: '64be9ebbac7134b09ba82639',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 63,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9ebe47d5a5cda2e0b59e',
                type: 'dropdown'
              },
              {
                field: '64be9ecc34d1d065271e9100',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 63,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9ece13785c1ac2b9469d',
                type: 'dropdown'
              },
              {
                field: '64be9ee7c45a721ef446f542',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 70,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9eeb4e1633326c8be5a1',
                type: 'dropdown'
              },
              {
                field: '64be9efe65752249f35e3f15',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12.06,
                y: 70,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9f00a8c3f0cf2f2822b5',
                type: 'dropdown'
              },
              {
                field: '64be9f95eaa1902dbe9e76d6',
                displayType: 'original',
                width: 22,
                height: 6,
                x: 1,
                y: 79,
                _id: '64be9f98d62c5b672abc52bb',
                type: 'richText'
              },
              {
                field: '64be9f9ef37ba25223a5a4a2',
                displayType: 'original',
                width: 22,
                height: 2,
                x: 1,
                y: 77,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '64be9fa0b3cbb08209a3e493',
                type: 'block'
              },
              {
                field: '64be9fd8dcb7a7eb334cb943',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 1,
                y: 85,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64be9fdb5762e459c8b70395',
                type: 'dropdown'
              },
              {
                field: '64bea005e783fac0e3fa9b8f',
                displayType: 'original',
                width: 11,
                height: 7,
                x: 12,
                y: 85,
                targetValue: '64be6c9328bd20c6bb432d43',
                titleFontColor: '#999999',
                _id: '64bea00704b90c236dfd83eb',
                type: 'dropdown'
              },
              {
                field: '64beaa59b97043b7c873323e',
                displayType: 'original',
                width: 22,
                height: 42,
                x: 1,
                y: 98,
                titleDisplay: 'none',
                _id: '64beaa5b34236a829f62e432',
                type: 'chart'
              },
              {
                field: '64beaaae50b74668c7651ecc',
                displayType: 'original',
                width: 22,
                height: 4,
                x: 1,
                y: 94,
                _id: '64beaaaf0c1e504f466ca83a',
                type: 'richText'
              },
              {
                field: '64beaad7f9fa367d374474c1',
                displayType: 'original',
                width: 22,
                height: 2,
                x: 1,
                y: 92,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '64beaad9d0063a6160ef3020',
                type: 'block'
              },
              {
                field: '64beab02ce96da7020c4494b',
                displayType: 'original',
                width: 22,
                height: 26,
                x: 1,
                y: 143,
                lineHeight: 15,
                _id: '64beab05d9085d6c92a1f0c4',
                type: 'textarea'
              },
              {
                field: '64beab3e2a02f076980a5f29',
                displayType: 'original',
                width: 22,
                height: 3,
                x: 1,
                y: 140,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                _id: '64beab417c43d4d81c49901f',
                type: 'block'
              },
              {
                field: '64beab70350b08d0099a61c3',
                displayType: 'original',
                width: 22,
                height: 5,
                x: 1,
                y: 169,
                _id: '64beab718ab25d7d19740a74',
                type: 'richText'
              }
            ],
            metadata: {},
            hidden: false,
            width: 816,
            height: 1056,
            cols: 24,
            rowHeight: 8,
            layout: 'grid',
            presentation: 'normal',
            margin: 5,
            padding: 0,
            borderColor: '#f28b8b',
            borderStyle: 'double',
            borderWidth: 8,
            _id: '64be9a826445afd6900f3902'
          }
        ],
        pageOrder: ['64be9a826445afd6900f3902'],
        views: [
          {
            type: 'mobile',
            pageOrder: [],
            pages: [
              {
                name: 'New Page',
                fieldPositions: [
                  {
                    field: '64be9aa9e38e1896e552bb08',
                    displayType: 'original',
                    width: 1,
                    height: 74,
                    x: 0,
                    y: 0,
                    _id: '64be9aaa44486e50d401ba63',
                    type: 'richText'
                  },
                  {
                    field: '64be9b9781d215b4c7fa17e9',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 130,
                    _id: '64be9b98c8d35889265eb5e4',
                    type: 'text'
                  },
                  {
                    field: '64be9be7a9d3edfcd976c070',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 74,
                    _id: '64be9be9c95b634cbd7b43b7',
                    type: 'date'
                  },
                  {
                    field: '64be9bc3c9d0b84b0dd3c4cc',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 186,
                    _id: '64be9bc50c20a126cbd893fd',
                    type: 'text'
                  },
                  {
                    field: '64be9c7aedaa69114f5ce19f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 354,
                    _id: '64be9c7c0b82872f19e13c2e',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9c2efa51d0110f7d1dcf',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 242,
                    _id: '64be9c30ca6dd1057cd92829',
                    type: 'text'
                  },
                  {
                    field: '64be9cf2837587e242fa2b0d',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 298,
                    _id: '64be9cf5857495559389d428',
                    type: 'text'
                  },
                  {
                    field: '64be9c131ab8450032a93a9b',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 410,
                    _id: '64be9c152c4ff9e8f435cfaa',
                    type: 'text'
                  },
                  {
                    field: '64be9e4c7c75340370ca6322',
                    displayType: 'original',
                    width: 1,
                    height: 17,
                    x: 0,
                    y: 466,
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    _id: '64be9e4d8e215ed5c5135331',
                    type: 'block'
                  },
                  {
                    field: '64be9df3d7e3ac0c46b4fc1f',
                    displayType: 'original',
                    width: 1,
                    height: 6,
                    x: 0,
                    y: 483,
                    borderColor: 'transparent',
                    backgroundColor: '#f28b8b',
                    _id: '64be9df5529dd45d1902c0b7',
                    type: 'block'
                  },
                  {
                    field: '64be9e55adce2d0137109ab6',
                    displayType: 'original',
                    width: 1,
                    height: 15,
                    x: 0,
                    y: 489,
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    _id: '64be9e575139fc755cbba629',
                    type: 'block'
                  },
                  {
                    field: '64be9dcc1bd8af33b28ac04e',
                    displayType: 'original',
                    width: 1,
                    height: 46,
                    x: 0,
                    y: 504,
                    _id: '64be9dcfed5b12bd042782ed',
                    type: 'richText'
                  },
                  {
                    field: '64be9e863a3c0c809386b55b',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 550,
                    _id: '64be9e88e9b62b2e1f5a2f60',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9e9e9484742a7569ca16',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 606,
                    _id: '64be9ea018f4b21938e77110',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9ebbac7134b09ba82639',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 662,
                    _id: '64be9ebe47d5a5cda2e0b59e',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9ecc34d1d065271e9100',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 718,
                    _id: '64be9ece13785c1ac2b9469d',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9ee7c45a721ef446f542',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 774,
                    _id: '64be9eeb4e1633326c8be5a1',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9efe65752249f35e3f15',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 830,
                    _id: '64be9f00a8c3f0cf2f2822b5',
                    type: 'dropdown'
                  },
                  {
                    field: '64be9f9ef37ba25223a5a4a2',
                    displayType: 'original',
                    width: 1,
                    height: 15,
                    x: 0,
                    y: 886,
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    _id: '64be9fa0b3cbb08209a3e493',
                    type: 'block'
                  },
                  {
                    field: '64be9f95eaa1902dbe9e76d6',
                    displayType: 'original',
                    width: 1,
                    height: 45,
                    x: 0,
                    y: 901,
                    _id: '64be9f98d62c5b672abc52bb',
                    type: 'richText'
                  },
                  {
                    field: '64be9fd8dcb7a7eb334cb943',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 946,
                    _id: '64be9fdb5762e459c8b70395',
                    type: 'dropdown'
                  },
                  {
                    field: '64bea005e783fac0e3fa9b8f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1002,
                    _id: '64bea00704b90c236dfd83eb',
                    type: 'dropdown'
                  },
                  {
                    field: '64beaad7f9fa367d374474c1',
                    displayType: 'original',
                    width: 1,
                    height: 16,
                    x: 0,
                    y: 1058,
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    _id: '64beaad9d0063a6160ef3020',
                    type: 'block'
                  },
                  {
                    field: '64beaaae50b74668c7651ecc',
                    displayType: 'original',
                    width: 1,
                    height: 33,
                    x: 0,
                    y: 1074,
                    _id: '64beaaaf0c1e504f466ca83a',
                    type: 'richText'
                  },
                  {
                    field: '64beaa59b97043b7c873323e',
                    displayType: 'original',
                    width: 1,
                    height: 211,
                    x: 0,
                    y: 1107,
                    titleDisplay: 'none',
                    _id: '64beaa5b34236a829f62e432',
                    type: 'chart'
                  },
                  {
                    field: '64beab3e2a02f076980a5f29',
                    displayType: 'original',
                    width: 1,
                    height: 17,
                    x: 0,
                    y: 1318,
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                    _id: '64beab417c43d4d81c49901f',
                    type: 'block'
                  },
                  {
                    field: '64beab02ce96da7020c4494b',
                    displayType: 'original',
                    width: 1,
                    height: 240,
                    x: 0,
                    y: 1335,
                    _id: '64beab05d9085d6c92a1f0c4',
                    type: 'textarea'
                  },
                  {
                    field: '64beab70350b08d0099a61c3',
                    displayType: 'original',
                    width: 1,
                    height: 55,
                    x: 0,
                    y: 1575,
                    _id: '64beab718ab25d7d19740a74',
                    type: 'richText'
                  }
                ],
                metadata: {},
                hidden: false,
                width: 816,
                height: 1056,
                cols: 1,
                rowHeight: 1,
                layout: 'grid',
                presentation: 'normal',
                margin: 0,
                padding: 12,
                borderWidth: 0,
                _id: '64be9a826445afd6900f3902'
              }
            ],
            _id: '64bfc69eb436a656112d087d'
          }
        ]
      }
    ],
    fields: [
      {
        type: 'richText',
        _id: '64be9aa9e38e1896e552bb08',
        identifier: 'field_64be9aaa44486e50d401ba63',
        title: 'Rich Text',
        description: '',
        value:
          '{"blocks":[{"key":"cma3d","text":"Fire Pump Annual Inspection, Testing, and","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":41,"style":"BOLD"},{"offset":0,"length":41,"style":"fontsize-18"}],"entityRanges":[],"data":{"text-align":"center"}},{"key":"1v8j8","text":" Maintenance Report","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":19,"style":"BOLD"},{"offset":0,"length":19,"style":"fontsize-18"}],"entityRanges":[],"data":{"text-align":"center"}}],"entityMap":{}}',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'image',
        _id: '64be9b545c0f26572f6a8665',
        identifier: 'field_64be9b55afd2e4674032159d',
        title: 'Image',
        description: '',
        value: [
          {
            _id: '64be9b7263b4b8a4f29a1d2e',
            url: 'https://s3.amazonaws.com/docspace.production.documents/63c2d5e152ae630f0e5cd53c/documents/64be9a828a5e09e48d7f63af/64be9b72b194a198c4b784e3-1690213234519.png',
            fileName: '64be9b72b194a198c4b784e3-1690213234519.png',
            filePath:
              '63c2d5e152ae630f0e5cd53c/documents/64be9a828a5e09e48d7f63af'
          }
        ],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        multi: false,
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'text',
        _id: '64be9b9781d215b4c7fa17e9',
        identifier: 'field_64be9b98c8d35889265eb5e4',
        title: 'Property Name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'text',
        _id: '64be9bc3c9d0b84b0dd3c4cc',
        identifier: 'field_64be9bc50c20a126cbd893fd',
        title: 'Property Address',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'date',
        _id: '64be9be7a9d3edfcd976c070',
        identifier: 'field_64be9be9c95b634cbd7b43b7',
        title: 'Date',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'text',
        _id: '64be9c131ab8450032a93a9b',
        identifier: 'field_64be9c152c4ff9e8f435cfaa',
        title: 'License #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'text',
        _id: '64be9c2efa51d0110f7d1dcf',
        identifier: 'field_64be9c30ca6dd1057cd92829',
        title: 'Contract Person',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9c7aedaa69114f5ce19f',
        identifier: 'field_64be9c7c0b82872f19e13c2e',
        title: 'Technician',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          {
            _id: '64be6c9328bd20c6bb432d43',
            value: 'Jake Bamfield',
            deleted: false
          },
          {
            _id: '64be6c93983879b28a641339',
            value: 'Terry Pierce',
            deleted: false
          },
          {
            _id: '64be6c93a7a184de2cca1b00',
            value: 'TJ Johnson',
            deleted: false
          }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'text',
        _id: '64be9cf2837587e242fa2b0d',
        identifier: 'field_64be9cf5857495559389d428',
        title: 'Phone',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'richText',
        _id: '64be9dcc1bd8af33b28ac04e',
        identifier: 'field_64be9dcfed5b12bd042782ed',
        title: 'Rich Text',
        description: '',
        value:
          '{"blocks":[{"key":"ddj9","text":"Electric Fire Pump System:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":26,"style":"BOLD"},{"offset":0,"length":26,"style":"fontsize-18"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64be9df3d7e3ac0c46b4fc1f',
        identifier: 'field_64be9df5529dd45d1902c0b7',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64be9e4c7c75340370ca6322',
        identifier: 'field_64be9e4d8e215ed5c5135331',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64be9e55adce2d0137109ab6',
        identifier: 'field_64be9e575139fc755cbba629',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9e863a3c0c809386b55b',
        identifier: 'field_64be9e88e9b62b2e1f5a2f60',
        title: '1. Lubricate bearings (NFPA 1.4.1)',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9e9e9484742a7569ca16',
        identifier: 'field_64be9ea018f4b21938e77110',
        title: '2. Power transfer switch',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9ebbac7134b09ba82639',
        identifier: 'field_64be9ebe47d5a5cda2e0b59e',
        title: '3. Check parallel and angular alignment',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9ecc34d1d065271e9100',
        identifier: 'field_64be9ece13785c1ac2b9469d',
        title: '4. Main relief valve',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9ee7c45a721ef446f542',
        identifier: 'field_64be9eeb4e1633326c8be5a1',
        title: '5. Check fl exible hoses and connections',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9efe65752249f35e3f15',
        identifier: 'field_64be9f00a8c3f0cf2f2822b5',
        title: '6. Pump coupling alignment',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'richText',
        _id: '64be9f95eaa1902dbe9e76d6',
        identifier: 'field_64be9f98d62c5b672abc52bb',
        title: 'Rich Text',
        description: '',
        value:
          '{"blocks":[{"key":"1h2ml","text":"Diesel Engine Fire Pump System:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"BOLD"},{"offset":0,"length":31,"style":"fontsize-18"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64be9f9ef37ba25223a5a4a2',
        identifier: 'field_64be9fa0b3cbb08209a3e493',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64be9fd8dcb7a7eb334cb943',
        identifier: 'field_64be9fdb5762e459c8b70395',
        title: 'Main relief valve',
        description: '',
        required: false,
        tipTitle: 'Example Title',
        tipDescription: 'Here are some instructions',
        tipVisible: true,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'dropdown',
        _id: '64bea005e783fac0e3fa9b8f',
        identifier: 'field_64bea00704b90c236dfd83eb',
        title: 'Fuel pump alarm signals',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '64be6c9328bd20c6bb432d43', value: 'Yes', deleted: false },
          { _id: '64be6c93983879b28a641339', value: 'No', deleted: false },
          { _id: '64be6c93a7a184de2cca1b00', value: 'N/A', deleted: false }
        ],
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'chart',
        _id: '64beaa59b97043b7c873323e',
        identifier: 'field_64beaa5b34236a829f62e432',
        title: 'Performance Graph',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        yTitle: 'PSI',
        yMax: 120,
        yMin: 0,
        xTitle: 'GPM',
        xMax: 2000,
        xMin: 0,
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'richText',
        _id: '64beaaae50b74668c7651ecc',
        identifier: 'field_64beaaaf0c1e504f466ca83a',
        title: 'Rich Text',
        description: '',
        value:
          '{"blocks":[{"key":"9518q","text":"Performance Graph:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":18,"style":"BOLD"},{"offset":0,"length":18,"style":"fontsize-18"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64beaad7f9fa367d374474c1',
        identifier: 'field_64beaad9d0063a6160ef3020',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'textarea',
        _id: '64beab02ce96da7020c4494b',
        identifier: 'field_64beab05d9085d6c92a1f0c4',
        title: 'Comments',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'block',
        _id: '64beab3e2a02f076980a5f29',
        identifier: 'field_64beab417c43d4d81c49901f',
        title: 'White Space',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      },
      {
        type: 'richText',
        _id: '64beab70350b08d0099a61c3',
        identifier: 'field_64beab718ab25d7d19740a74',
        title: 'Rich Text',
        description: '',
        value:
          '{"blocks":[{"key":"em2h8","text":"Inspection performed in accordance with NFPA 25 Standard for the Inspection, Testing, and Maintenance of Water-Based Fire Protection Systems, 2020 edition. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":156,"style":"fontsize-10"},{"offset":0,"length":156,"style":"color-#999999"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '64be9a826eefbc6b2dda0222'
      }
    ],
    deleted: false,
    categories: []
  },
  templateFour: {
    _id: '65d0e0baf33a76f29da97b70',
    type: 'template',
    stage: 'draft',
    metadata: {},
    identifier: 'template_65d0e0baf33a76f29da97b70',
    name: 'First Report of Injury or Illness Form',
    createdOn: 1708187962914,
    files: [
      {
        _id: '65d0e0ba32859807c91f3d4a',
        metadata: {},
        name: 'First Report of Injury or Illness Form',
        version: 1,
        styles: { titleFontSize: 11, fontSize: 11, textAlign: 'left' },
        pages: [
          {
            name: 'New Page',
            fieldPositions: [
              {
                field: '65d0e5a4e3b6404bea23d0fd',
                displayType: 'original',
                width: 404.76,
                height: 21.25,
                x: 139.17,
                y: 110.49,
                titleDisplay: 'none',
                _id: '65d0e5ab8d8c9b8b7d691fec',
                type: 'text'
              },
              {
                field: '65d0e5f3d10bddbc86484109',
                displayType: 'original',
                width: 446.2,
                height: 19.12,
                x: 97.74,
                y: 131.73,
                titleDisplay: 'none',
                _id: '65d0e5fd1d8928501d7311d4',
                type: 'text'
              },
              {
                field: '65d0e6223f4331c2f5dffbcb',
                displayType: 'original',
                width: 285.78,
                height: 19.12,
                x: 76.49,
                y: 151.92,
                titleDisplay: 'none',
                _id: '65d0e62a1092a683eea0e472',
                type: 'text'
              },
              {
                field: '65d0e654a6401c9e7bdd5c8c',
                displayType: 'original',
                width: 41.43,
                height: 19.12,
                x: 393.08,
                y: 151.92,
                titleDisplay: 'none',
                _id: '65d0e65af81a27ff427c10e0',
                type: 'text'
              },
              {
                field: '65d0e67f16c0a099e9f5b5ab',
                displayType: 'original',
                width: 83.93,
                height: 19.12,
                x: 460.01,
                y: 151.92,
                titleDisplay: 'none',
                _id: '65d0e6849978845b74995b19',
                type: 'text'
              },
              {
                field: '65d0e6b3c1f1f5ef3301914f',
                displayType: 'original',
                width: 216.72,
                height: 18.06,
                x: 97.74,
                y: 172.1,
                titleDisplay: 'none',
                _id: '65d0e6bb4827d38865a2705a',
                type: 'text'
              },
              {
                field: '65d0e6e47a9bdaa3c21ef637',
                displayType: 'original',
                width: 189.1,
                height: 18.06,
                x: 353.77,
                y: 172.1,
                titleDisplay: 'none',
                _id: '65d0e6fdd08717d384b427b8',
                type: 'text'
              },
              {
                field: '65d0e716ccc237f61a4ba55d',
                displayType: 'original',
                width: 294.28,
                height: 20.19,
                x: 248.6,
                y: 191.23,
                titleDisplay: 'none',
                _id: '65d0e71cb0649482a4ab49e2',
                type: 'text'
              },
              {
                field: '65d0e76e60a5efebd27663ed',
                displayType: 'original',
                width: 445.13,
                height: 18.06,
                x: 97.74,
                y: 212.47,
                titleDisplay: 'none',
                _id: '65d0e782ed813730887c9372',
                type: 'text'
              },
              {
                field: '65d0e79ce619f705df0066f5',
                displayType: 'original',
                width: 286.84,
                height: 19.12,
                x: 76.49,
                y: 231.6,
                titleDisplay: 'none',
                _id: '65d0e7a20fedbcd1fbab9ec2',
                type: 'text'
              },
              {
                field: '65d0e7c54be4757982f61298',
                displayType: 'original',
                width: 39.31,
                height: 20.19,
                x: 394.14,
                y: 230.54,
                titleDisplay: 'none',
                _id: '65d0e7ca446454944671fb68',
                type: 'text'
              },
              {
                field: '65d0e7e647ca425a1a913307',
                displayType: 'original',
                width: 81.8,
                height: 20.19,
                x: 458.95,
                y: 231.6,
                titleDisplay: 'none',
                _id: '65d0e7eb1e4e7f491d2c167e',
                type: 'text'
              },
              {
                field: '65d0e8184d0073cfa384ac80',
                displayType: 'original',
                width: 415.39,
                height: 19.12,
                x: 126.42,
                y: 251.78,
                titleDisplay: 'none',
                _id: '65d0e81f4fba0386cc01b607',
                type: 'text'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 564.12,
                y: 134.92,
                targetValue: '65d0def9fb2704aa0fef7931',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0e858b1993c1d0cf0b84b',
                type: 'multiSelect'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 11.69,
                height: 12.75,
                x: 655.48,
                y: 134.92,
                targetValue: '65d0def9c4a0d47ddd10115a',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0e90e199a75da34895179',
                type: 'multiSelect'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 12.75,
                height: 11.69,
                x: 695.86,
                y: 134.92,
                targetValue: '65d0def99cd72dbdb88f902a',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0e96315895cb4c691d642',
                type: 'multiSelect'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 12.75,
                height: 13.81,
                x: 564.12,
                y: 154.04,
                targetValue: '65d0e8db2bd27bdd43afc8ba',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0e97be03739f8d9ee2fc4',
                type: 'multiSelect'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 10.62,
                height: 11.69,
                x: 655.48,
                y: 155.11,
                targetValue: '65d0e8eb5f6f875511704754',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0e9f2291c1da86f932d1e',
                type: 'multiSelect'
              },
              {
                field: '65d0e842d603cdcca008c6a6',
                displayType: 'check',
                width: 10.62,
                height: 12.75,
                x: 745.79,
                y: 154.04,
                targetValue: '65d0e8f759ea630bf7f7cb3b',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0ea09d8bc7e9659029f1d',
                type: 'multiSelect'
              },
              {
                field: '65d0ea34a92b89fad0b4260f',
                displayType: 'check',
                width: 13.81,
                height: 10.62,
                x: 711.79,
                y: 192.29,
                targetValue: '65d0def90ecc49473781afa2',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0ea4041fc09076b2bb58e',
                type: 'dropdown'
              },
              {
                field: '65d0ea34a92b89fad0b4260f',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 752.16,
                y: 191.23,
                targetValue: '65d0def98546059c5e2c5569',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0f36ce5ffaa5955d66543',
                type: 'dropdown'
              },
              {
                field: '65d0f3816eb10dda55b73fed',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 697.98,
                y: 230.54,
                targetValue: '65d0def90ecc49473781afa2',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0f3919dc97f61fb9b6a35',
                type: 'dropdown'
              },
              {
                field: '65d0f3816eb10dda55b73fed',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 745.79,
                y: 231.6,
                targetValue: '65d0def98546059c5e2c5569',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d0f4b8d06f183fa0710096',
                type: 'dropdown'
              },
              {
                field: '65d0f4f4c75da8f37acbabe8',
                displayType: 'original',
                width: 152.98,
                height: 18.06,
                x: 641.67,
                y: 251.78,
                titleDisplay: 'none',
                _id: '65d0f5079a644537a0e811ea',
                type: 'text'
              },
              {
                field: '65d1d3384298244323051661',
                displayType: 'original',
                width: 377.14,
                height: 19.12,
                x: 163.61,
                y: 270.91,
                titleDisplay: 'none',
                _id: '65d1d34740240c1f0fdc8ddc',
                type: 'text'
              },
              {
                field: '65d1d37179acabe8a8a48985',
                displayType: 'original',
                width: 378.21,
                height: 18.06,
                x: 163.61,
                y: 291.09,
                titleDisplay: 'none',
                _id: '65d1d37c870baa1a2ee2c82d',
                type: 'text'
              },
              {
                field: '65d1d3a3ee3eef6ac45c45a3',
                displayType: 'original',
                width: 444.07,
                height: 18.06,
                x: 97.74,
                y: 309.15,
                titleDisplay: 'none',
                _id: '65d1d3ae51f6b8216a46e939',
                type: 'text'
              },
              {
                field: '65d1d3d819c020e78f534d59',
                displayType: 'original',
                width: 286.84,
                height: 18.06,
                x: 76.49,
                y: 329.34,
                titleDisplay: 'none',
                _id: '65d1d3dd94550000d40357e2',
                type: 'text'
              },
              {
                field: '65d1d3f3158f7ec1e8b6bbbc',
                displayType: 'original',
                width: 46.74,
                height: 19.12,
                x: 394.14,
                y: 328.27,
                titleDisplay: 'none',
                _id: '65d1d3f871bc5f7be52d2a1f',
                type: 'text'
              },
              {
                field: '65d1d40f56cd2d6b9c07c180',
                displayType: 'original',
                width: 79.68,
                height: 17,
                x: 463.2,
                y: 329.34,
                titleDisplay: 'none',
                _id: '65d1d413c6cf60428efbe50f',
                type: 'text'
              },
              {
                field: '65d1d434fff6324f1012fdf6',
                displayType: 'original',
                width: 441.95,
                height: 18.06,
                x: 100.93,
                y: 348.46,
                titleDisplay: 'none',
                _id: '65d1d448e2ee2a3de9e624eb',
                type: 'text'
              },
              {
                field: '65d1d46b1d386548a32eb112',
                displayType: 'original',
                width: 426.01,
                height: 18.06,
                x: 115.8,
                y: 367.58,
                titleDisplay: 'none',
                _id: '65d1d4788f49686fc99d5bc4',
                type: 'text'
              },
              {
                field: '65d1d4b8040f0d98dfe1851d',
                displayType: 'original',
                width: 269.84,
                height: 18.06,
                x: 270.91,
                y: 386.7,
                titleDisplay: 'none',
                _id: '65d1d4c052cf73626735b4b2',
                type: 'text'
              },
              {
                field: '65d1d500a96bc4230df101a0',
                displayType: 'original',
                width: 183.79,
                height: 18.06,
                x: 151.92,
                y: 406.89,
                titleDisplay: 'none',
                _id: '65d1d506849bcea3e102439f',
                type: 'text'
              },
              {
                field: '65d1d521c17ec313c7488715',
                displayType: 'check',
                width: 12.75,
                height: 13.81,
                x: 436.64,
                y: 406.89,
                targetValue: '65d0faf0021ff927262b3ec4',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d52e5c23534e4396fb52',
                type: 'multiSelect'
              },
              {
                field: '65d1d521c17ec313c7488715',
                displayType: 'check',
                width: 10.62,
                height: 12.75,
                x: 491.88,
                y: 407.95,
                targetValue: '65d0faf035a07cda62689d12',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d63f916c893083fd6b8d',
                type: 'multiSelect'
              },
              {
                field: '65d1d521c17ec313c7488715',
                displayType: 'check',
                width: 12.75,
                height: 13.81,
                x: 563.06,
                y: 407.95,
                targetValue: '65d1d5eac6755fdd5b5fc342',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d65f3e9c3b033470e21f',
                type: 'multiSelect'
              },
              {
                field: '65d1d521c17ec313c7488715',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 616.18,
                y: 407.95,
                targetValue: '65d1d5fc5af06a92ab00c833',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d66ffeee58d80946412e',
                type: 'multiSelect'
              },
              {
                field: '65d1d521c17ec313c7488715',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 682.04,
                y: 407.95,
                targetValue: '65d1d609ab3aa86d4d802a68',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d67e12118aaff9cabcc6',
                type: 'multiSelect'
              },
              {
                field: '65d1d7f56aabcba35e031b48',
                displayType: 'original',
                width: 152.98,
                height: 17,
                x: 640.61,
                y: 273.03,
                titleDisplay: 'none',
                _id: '65d1d7fcef4db7b19c7327f3',
                type: 'text'
              },
              {
                field: '65d1d82138efdfc80778a868',
                displayType: 'original',
                width: 183.79,
                height: 18.06,
                x: 610.87,
                y: 291.09,
                titleDisplay: 'none',
                _id: '65d1d827320387c7d911c9ea',
                type: 'text'
              },
              {
                field: '65d1d875a650de8f7e284b41',
                displayType: 'original',
                width: 146.61,
                height: 18.06,
                x: 646.99,
                y: 309.15,
                titleDisplay: 'none',
                _id: '65d1d87b6e8550075120dd05',
                type: 'text'
              },
              {
                field: '65d1d8c80622a530987b72e5',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 605.55,
                y: 331.46,
                targetValue: '65d0faf0021ff927262b3ec4',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d8d11e600079fba4dacb',
                type: 'multiSelect'
              },
              {
                field: '65d1d8c80622a530987b72e5',
                displayType: 'check',
                width: 10.62,
                height: 10.62,
                x: 671.42,
                y: 332.52,
                targetValue: '65d0faf03b02129b7310c072',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1d9311ff7eb1fdd061e4c',
                type: 'multiSelect'
              },
              {
                field: '65d1d950a0957ed7a50d85d4',
                displayType: 'original',
                width: 154.04,
                height: 18.06,
                x: 639.55,
                y: 348.46,
                titleDisplay: 'none',
                _id: '65d1d965683be6635f1b8ede',
                type: 'text'
              },
              {
                field: '65d1d9980c14c928135beef7',
                displayType: 'original',
                width: 188.04,
                height: 19.12,
                x: 605.55,
                y: 367.58,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1da0b887238691983a7ec',
                type: 'date'
              },
              {
                field: '65d1da3234d6d6abfa51cc23',
                displayType: 'original',
                width: 186.98,
                height: 18.06,
                x: 606.62,
                y: 386.7,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1da38e999e5af642380a2',
                type: 'date'
              },
              {
                field: '65d1de4af7edec2b545c7384',
                displayType: 'original',
                width: 46.74,
                height: 18.06,
                x: 120.05,
                y: 424.95,
                titleDisplay: 'none',
                _id: '65d1de55d491c4eaa41a60b2',
                type: 'text'
              },
              {
                field: '65d1de9da3260d4360eb53e7',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 214.6,
                y: 429.2,
                targetValue: '65d1dc69cec511656b749c1a',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1deac52fbc66432c8c4d5',
                type: 'multiSelect'
              },
              {
                field: '65d1de9da3260d4360eb53e7',
                displayType: 'check',
                width: 11.69,
                height: 12.75,
                x: 265.59,
                y: 428.14,
                targetValue: '65d1dc69167aebe49de54148',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1df8db6551ce5b9a4a9b7',
                type: 'multiSelect'
              },
              {
                field: '65d1de9da3260d4360eb53e7',
                displayType: 'check',
                width: 12.75,
                height: 11.69,
                x: 329.34,
                y: 429.2,
                targetValue: '65d1dc698b768647e1fbb992',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1dfc880620f55b523ec01',
                type: 'multiSelect'
              },
              {
                field: '65d1de9da3260d4360eb53e7',
                displayType: 'check',
                width: 12.75,
                height: 10.62,
                x: 388.83,
                y: 429.2,
                targetValue: '65d1df4cadf39ae694af0ee6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1dfebf29a343d86b33f4a',
                type: 'multiSelect'
              },
              {
                field: '65d1de9da3260d4360eb53e7',
                displayType: 'check',
                width: 13.81,
                height: 12.75,
                x: 448.32,
                y: 428.14,
                targetValue: '65d1df5fc3aa3376d9a25041',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1e01951cb6e694833cdb0',
                type: 'multiSelect'
              },
              {
                field: '65d1e04405d7da535f7d4bc8',
                displayType: 'original',
                width: 91.36,
                height: 18.06,
                x: 185.92,
                y: 444.07,
                titleDisplay: 'none',
                _id: '65d1e04e67e96eab748673c8',
                type: 'text'
              },
              {
                field: '65d1e099139e32b9bf5c3e31',
                displayType: 'check',
                width: 12.75,
                height: 11.69,
                x: 424.95,
                y: 447.26,
                targetValue: '65d1dc69d3604a218522469e',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1e0a553090a18472cded9',
                type: 'dropdown'
              },
              {
                field: '65d1e099139e32b9bf5c3e31',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 461.07,
                y: 446.2,
                targetValue: '65d1dc698ce3884bf86649c4',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1e0e86437468fefdd43e4',
                type: 'dropdown'
              },
              {
                field: '65d1e10649aecfcd473a47bd',
                displayType: 'original',
                width: 132.8,
                height: 20.19,
                x: 656.55,
                y: 423.89,
                titleDisplay: 'none',
                _id: '65d1e111aaa911101a0cd84c',
                type: 'text'
              },
              {
                field: '65d1f43005b59e9ac8c79b55',
                displayType: 'check',
                width: 13.81,
                height: 11.69,
                x: 638.49,
                y: 447.26,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f441a9dd1428479edb07',
                type: 'multiSelect'
              },
              {
                field: '65d1f43005b59e9ac8c79b55',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 675.67,
                y: 446.2,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f4894cfa4a1b5d67b813',
                type: 'multiSelect'
              },
              {
                field: '65d1f4b78c68ced36101cd83',
                displayType: 'original',
                width: 223.1,
                height: 18.06,
                x: 570.49,
                y: 463.2,
                titleDisplay: 'none',
                _id: '65d1f4c5530a4603c4a94b3b',
                type: 'text'
              },
              {
                field: '65d1f51cfb37784612a66de1',
                displayType: 'original',
                width: 220.97,
                height: 18.06,
                x: 571.56,
                y: 482.32,
                titleDisplay: 'none',
                _id: '65d1f525b9a05b6b406caf15',
                type: 'text'
              },
              {
                field: '65d1f5bde7289c3fde1ab4cb',
                displayType: 'original',
                width: 378.21,
                height: 18.06,
                x: 247.53,
                y: 502.5,
                titleDisplay: 'none',
                _id: '65d1f5c792181eaa2c65e899',
                type: 'text'
              },
              {
                field: '65d1f60e0c0013edc89db276',
                displayType: 'original',
                width: 111.55,
                height: 19.12,
                x: 679.92,
                y: 501.44,
                titleDisplay: 'none',
                _id: '65d1f616f7e40fed67981bf2',
                type: 'text'
              },
              {
                field: '65d1f63997f9c5ec5a8ddac7',
                displayType: 'original',
                width: 193.35,
                height: 18.06,
                x: 91.36,
                y: 521.63,
                titleDisplay: 'none',
                _id: '65d1f6462587ade5d5d6ced6',
                type: 'text'
              },
              {
                field: '65d1f6672d9010fb33ff0b6d',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 566.25,
                y: 524.81,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f6a7f3718407b265713d',
                type: 'multiSelect'
              },
              {
                field: '65d1f6672d9010fb33ff0b6d',
                displayType: 'check',
                width: 12.75,
                height: 10.62,
                x: 602.37,
                y: 525.88,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f70e5638165987a76100',
                type: 'multiSelect'
              },
              {
                field: '65d1f73458e8b29662412089',
                displayType: 'original',
                width: 57.37,
                height: 18.06,
                x: 154.04,
                y: 540.75,
                format: 'hh:mma',
                titleDisplay: 'none',
                _id: '65d1f77c2b694e5f8c2fb4d5',
                type: 'date'
              },
              {
                field: '65d1f7bfc78de58a2158ac93',
                displayType: 'check',
                width: 14.87,
                height: 12.75,
                x: 213.54,
                y: 543.94,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f7c661dafb335d3f20fd',
                type: 'multiSelect'
              },
              {
                field: '65d1f7bfc78de58a2158ac93',
                displayType: 'check',
                width: 11.69,
                height: 12.75,
                x: 248.6,
                y: 543.94,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f8027a81fa23e9c5d57d',
                type: 'multiSelect'
              },
              {
                field: '65d1f83c0600145c640174bf',
                displayType: 'original',
                width: 62.68,
                height: 18.06,
                x: 644.86,
                y: 541.81,
                format: 'hh:mma',
                titleDisplay: 'none',
                _id: '65d1f84883eb7578629ff819',
                type: 'date'
              },
              {
                field: '65d1f873ee3086a86b8dc47e',
                displayType: 'check',
                width: 11.69,
                height: 10.62,
                x: 712.85,
                y: 546.06,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f88ada463cda74a5ba09',
                type: 'multiSelect'
              },
              {
                field: '65d1f873ee3086a86b8dc47e',
                displayType: 'check',
                width: 11.69,
                height: 10.62,
                x: 746.85,
                y: 545,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1f8dbbc1d656376dc273d',
                type: 'multiSelect'
              },
              {
                field: '65d1f9050755290ef6a7229f',
                displayType: 'original',
                width: 149.79,
                height: 17,
                x: 137.05,
                y: 559.87,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1f912256a915134b94114',
                type: 'date'
              },
              {
                field: '65d1f93f701dbf46d408c2f1',
                displayType: 'original',
                width: 124.3,
                height: 17,
                x: 398.39,
                y: 559.87,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1f94ff8a7b871d3f2334a',
                type: 'date'
              },
              {
                field: '65d1f977daf78f6b224bff9a',
                displayType: 'original',
                width: 161.42,
                height: 17,
                x: 629.99,
                y: 559.87,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1f98208a005e8a4d26904',
                type: 'date'
              },
              {
                field: '65d1f9aeed0a369a66a4e9d3',
                displayType: 'original',
                width: 123.24,
                height: 18.06,
                x: 160.42,
                y: 580.06,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d1f9bb3fcf69be49db5e44',
                type: 'date'
              },
              {
                field: '65d1f9e6707eb5d28af52021',
                displayType: 'original',
                width: 134.92,
                height: 17,
                x: 390.95,
                y: 578.99,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                fontSize: 11,
                _id: '65d1f9f62bbe5c01e99ce528',
                type: 'date'
              },
              {
                field: '65d1fa21646e1d3d61ca94bb',
                displayType: 'original',
                width: 132.8,
                height: 19.12,
                x: 659.73,
                y: 578.99,
                titleDisplay: 'none',
                _id: '65d1fa29acac3319c75688aa',
                type: 'text'
              },
              {
                field: '65d1fa63dd2c5e93a6932222',
                displayType: 'original',
                width: 368.64,
                height: 21.25,
                x: 156.17,
                y: 598.12,
                titleDisplay: 'none',
                fontSize: 11,
                _id: '65d1fa7c107857173fefd7c3',
                type: 'text'
              },
              {
                field: '65d1faa63f2cca70b5f87271',
                displayType: 'check',
                width: 12.75,
                height: 13.81,
                x: 649.11,
                y: 600.24,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1fab0c6bae1c3b5d04fd3',
                type: 'multiSelect'
              },
              {
                field: '65d1faa63f2cca70b5f87271',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 685.23,
                y: 601.3,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d1fc118ff82d26293031b0',
                type: 'multiSelect'
              },
              {
                field: '65d1fc533789b1c5d8b89d11',
                displayType: 'original',
                width: 552.43,
                height: 19.12,
                x: 241.16,
                y: 617.24,
                titleDisplay: 'none',
                _id: '65d1fc5f882334a079f52faa',
                type: 'text'
              },
              {
                field: '65d1fc8fd78dd086e4f95eaf',
                displayType: 'original',
                width: 387.77,
                height: 19.12,
                x: 405.83,
                y: 636.36,
                titleDisplay: 'none',
                _id: '65d1fc9e4680ac4c3549a507',
                type: 'text'
              },
              {
                field: '65d1fcf2a74ee289f74ba4c0',
                displayType: 'original',
                width: 751.1,
                height: 62.68,
                x: 45.68,
                y: 668.23,
                titleDisplay: 'none',
                lineHeight: 25,
                fontSize: 11,
                _id: '65d1fd0e5758c5540bc9e668',
                type: 'textarea'
              },
              {
                field: '65d202f090d127ede8c4427d',
                displayType: 'check',
                width: 11.69,
                height: 11.69,
                x: 343.15,
                y: 735.16,
                targetValue: '65d1e1d56763e46a1602ba45',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d202fbe6b93bb9165bb5f9',
                type: 'dropdown'
              },
              {
                field: '65d202f090d127ede8c4427d',
                displayType: 'check',
                width: 10.62,
                height: 11.69,
                x: 380.33,
                y: 735.16,
                targetValue: '65d1e1d58dbc9af825cf162c',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d2035b53b0d42e159bcc20',
                type: 'dropdown'
              },
              {
                field: '65d2037d57324eba8db5c3b3',
                displayType: 'original',
                width: 481.26,
                height: 48.87,
                x: 45.68,
                y: 778.72,
                titleDisplay: 'none',
                lineHeight: 25,
                _id: '65d20398aa24f854db74487a',
                type: 'textarea'
              },
              {
                field: '65d203f65f26f030afb036e9',
                displayType: 'check',
                width: 13.81,
                height: 12.75,
                x: 691.61,
                y: 734.1,
                targetValue: '65d1e1d56763e46a1602ba45',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d203ff99f0f93b930042ac',
                type: 'dropdown'
              },
              {
                field: '65d203f65f26f030afb036e9',
                displayType: 'check',
                width: 12.75,
                height: 11.69,
                x: 728.79,
                y: 735.16,
                targetValue: '65d1e1d58dbc9af825cf162c',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d204597e88f1ad39ded889',
                type: 'dropdown'
              },
              {
                field: '65d20478054108a19e043da4',
                displayType: 'check',
                width: 13.81,
                height: 11.69,
                x: 598.12,
                y: 754.29,
                targetValue: '65d1e1d56763e46a1602ba45',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d2048956fc96e788e7b62d',
                type: 'dropdown'
              },
              {
                field: '65d20478054108a19e043da4',
                displayType: 'check',
                width: 12.75,
                height: 11.69,
                x: 634.24,
                y: 754.29,
                targetValue: '65d1e1d58dbc9af825cf162c',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d204d5a36059d33e10e0e7',
                type: 'dropdown'
              },
              {
                field: '65d20512e5462b67bcac816f',
                displayType: 'check',
                width: 13.81,
                height: 13.81,
                x: 692.67,
                y: 772.35,
                targetValue: '65d1e1d56763e46a1602ba45',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d20534ef5e0cdf63d70d52',
                type: 'dropdown'
              },
              {
                field: '65d20512e5462b67bcac816f',
                displayType: 'check',
                width: 14.87,
                height: 12.75,
                x: 728.79,
                y: 772.35,
                targetValue: '65d1e1d58dbc9af825cf162c',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d205a85225937edf016ff0',
                type: 'dropdown'
              },
              {
                field: '65d205c178ee2c1777c19d86',
                displayType: 'original',
                width: 125.36,
                height: 22.31,
                x: 661.86,
                y: 789.34,
                titleDisplay: 'none',
                _id: '65d205d17f56e73a21e5f5c3',
                type: 'text'
              },
              {
                field: '65d206427f1fe34e3351fb51',
                displayType: 'original',
                width: 227.35,
                height: 18.06,
                x: 250.72,
                y: 828.65,
                titleDisplay: 'none',
                _id: '65d2064dfcdf171b60ae61d0',
                type: 'text'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 14.87,
                height: 14.87,
                x: 484.44,
                y: 829.71,
                targetValue: '65d1e1d51237462cdf89b3d6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d206c72852f54b8d3221be',
                type: 'multiSelect'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 11.69,
                height: 13.81,
                x: 486.57,
                y: 848.84,
                targetValue: '65d1e1d544f817a1374f24fd',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d207d0978fcd9000540dc2',
                type: 'multiSelect'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 13.81,
                height: 12.75,
                x: 485.51,
                y: 869.02,
                targetValue: '65d1e1d52534c77231913602',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d207f636879b4f260f4835',
                type: 'multiSelect'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 657.61,
                y: 830.78,
                targetValue: '65d207744e091f9cda5bf8a6',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d2082a605bd0028b76ee80',
                type: 'multiSelect'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 11.69,
                height: 12.75,
                x: 659.73,
                y: 849.9,
                targetValue: '65d2078d302ba1342df82a6b',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d208848760d8f5eeea0919',
                type: 'multiSelect'
              },
              {
                field: '65d206b092d789d8ac93ed6f',
                displayType: 'check',
                width: 12.75,
                height: 13.81,
                x: 658.67,
                y: 867.96,
                targetValue: '65d207ac9a5ed91fff1ab88f',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d208ba53fc56aac0b578cd',
                type: 'multiSelect'
              },
              {
                field: '65d208f5154127b3a2a07fe2',
                displayType: 'check',
                width: 13.81,
                height: 13.81,
                x: 213.54,
                y: 889.21,
                targetValue: '65d1e1d56763e46a1602ba45',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d2090e324a76d8ba471ebb',
                type: 'dropdown'
              },
              {
                field: '65d208f5154127b3a2a07fe2',
                displayType: 'check',
                width: 12.75,
                height: 12.75,
                x: 251.78,
                y: 890.27,
                targetValue: '65d1e1d58dbc9af825cf162c',
                titleDisplay: 'none',
                borderColor: '#BAC4CF',
                borderWidth: 1,
                _id: '65d209ceeb6b9bc837f01509',
                type: 'dropdown'
              },
              {
                field: '65d209f3d1aa7990eb7a4b3d',
                displayType: 'original',
                width: 342.08,
                height: 20.19,
                x: 447.26,
                y: 884.96,
                titleDisplay: 'none',
                _id: '65d209fef66c8d015a78d764',
                type: 'text'
              },
              {
                field: '65d20a2a14d8bac77f65b244',
                displayType: 'original',
                width: 614.05,
                height: 19.12,
                x: 175.29,
                y: 906.21,
                titleDisplay: 'none',
                _id: '65d20a38058dc9a8ec6d5cb0',
                type: 'text'
              },
              {
                field: '65d20a750f0a7e57fc0c0520',
                displayType: 'original',
                width: 328.27,
                height: 20.19,
                x: 178.48,
                y: 924.27,
                titleDisplay: 'none',
                _id: '65d20a844f7c2d12ed49032c',
                type: 'text'
              },
              {
                field: '65d20aefa0f671dead87b046',
                displayType: 'original',
                width: 209.29,
                height: 19.12,
                x: 581.12,
                y: 925.33,
                format: 'MM/DD/YYYY',
                titleDisplay: 'none',
                _id: '65d20afcf2058b546c8ff976',
                type: 'date'
              },
              {
                field: '65db36e03a3340e635ebda49',
                displayType: 'original',
                width: 430.26,
                height: 39.31,
                x: 47.81,
                y: 844.59,
                titleDisplay: 'none',
                lineHeight: 50,
                _id: '65db36e2b6c4af2e12f1292d',
                type: 'textarea'
              }
            ],
            metadata: {},
            hidden: false,
            fileName: '65d0e169dd5e871ecd427585-1708188009015.png',
            filePath:
              '64f76cb572e7ea6c88ec2719/documents/template_65d0e0baf33a76f29da97b70',
            width: 816,
            height: 1056,
            cols: 816,
            rowHeight: 1,
            layout: 'float',
            presentation: 'transparent',
            margin: 0,
            padding: 0,
            borderWidth: 0,
            backgroundImage:
              'https://s3.amazonaws.com/docspace.production.documents/64f76cb572e7ea6c88ec2719/documents/template_65d0e0baf33a76f29da97b70/65d0e169dd5e871ecd427585-1708188009015.png',
            _id: '65d0e0ba86479093a095ed5f'
          }
        ],
        pageOrder: ['65d0e0ba86479093a095ed5f'],
        views: [
          {
            type: 'mobile',
            pageOrder: ['65d0e0ba86479093a095ed5f'],
            pages: [
              {
                name: 'New Page',
                fieldPositions: [
                  {
                    field: '65d0e5a4e3b6404bea23d0fd',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 200,
                    _id: '65d0e5ab8d8c9b8b7d691fec',
                    type: 'text'
                  },
                  {
                    field: '65d0e5f3d10bddbc86484109',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 256,
                    _id: '65d0e5fd1d8928501d7311d4',
                    type: 'text'
                  },
                  {
                    field: '65d0e842d603cdcca008c6a6',
                    displayType: 'original',
                    width: 1,
                    height: 92,
                    x: 0,
                    y: 928,
                    _id: '65d0e858b1993c1d0cf0b84b',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d0e6223f4331c2f5dffbcb',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 312,
                    _id: '65d0e62a1092a683eea0e472',
                    type: 'text'
                  },
                  {
                    field: '65d0e654a6401c9e7bdd5c8c',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 368,
                    _id: '65d0e65af81a27ff427c10e0',
                    type: 'text'
                  },
                  {
                    field: '65d0e67f16c0a099e9f5b5ab',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 424,
                    _id: '65d0e6849978845b74995b19',
                    type: 'text'
                  },
                  {
                    field: '65d0e6b3c1f1f5ef3301914f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 480,
                    _id: '65d0e6bb4827d38865a2705a',
                    type: 'text'
                  },
                  {
                    field: '65d0e6e47a9bdaa3c21ef637',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 536,
                    _id: '65d0e6fdd08717d384b427b8',
                    type: 'text'
                  },
                  {
                    field: '65d0e716ccc237f61a4ba55d',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 592,
                    _id: '65d0e71cb0649482a4ab49e2',
                    type: 'text'
                  },
                  {
                    field: '65d0ea34a92b89fad0b4260f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1020,
                    _id: '65d0f36ce5ffaa5955d66543',
                    type: 'dropdown'
                  },
                  {
                    field: '65d0e76e60a5efebd27663ed',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 648,
                    _id: '65d0e782ed813730887c9372',
                    type: 'text'
                  },
                  {
                    field: '65d0e7c54be4757982f61298',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 760,
                    _id: '65d0e7ca446454944671fb68',
                    type: 'text'
                  },
                  {
                    field: '65d0f3816eb10dda55b73fed',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1076,
                    _id: '65d0f3919dc97f61fb9b6a35',
                    type: 'dropdown'
                  },
                  {
                    field: '65d0e79ce619f705df0066f5',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 704,
                    _id: '65d0e7a20fedbcd1fbab9ec2',
                    type: 'text'
                  },
                  {
                    field: '65d0e7e647ca425a1a913307',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 816,
                    _id: '65d0e7eb1e4e7f491d2c167e',
                    type: 'text'
                  },
                  {
                    field: '65d0e8184d0073cfa384ac80',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 872,
                    _id: '65d0e81f4fba0386cc01b607',
                    type: 'text'
                  },
                  {
                    field: '65d0f4f4c75da8f37acbabe8',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1132,
                    _id: '65d0f5079a644537a0e811ea',
                    type: 'text'
                  },
                  {
                    field: '65d1d3384298244323051661',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1228,
                    _id: '65d1d34740240c1f0fdc8ddc',
                    type: 'text'
                  },
                  {
                    field: '65d1d7f56aabcba35e031b48',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1732,
                    _id: '65d1d7fcef4db7b19c7327f3',
                    type: 'text'
                  },
                  {
                    field: '65d1d37179acabe8a8a48985',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1284,
                    _id: '65d1d37c870baa1a2ee2c82d',
                    type: 'text'
                  },
                  {
                    field: '65d1d82138efdfc80778a868',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1788,
                    _id: '65d1d827320387c7d911c9ea',
                    type: 'text'
                  },
                  {
                    field: '65d1d3a3ee3eef6ac45c45a3',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1340,
                    _id: '65d1d3ae51f6b8216a46e939',
                    type: 'text'
                  },
                  {
                    field: '65d1d875a650de8f7e284b41',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1844,
                    _id: '65d1d87b6e8550075120dd05',
                    type: 'text'
                  },
                  {
                    field: '65d1d3f3158f7ec1e8b6bbbc',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1452,
                    _id: '65d1d3f871bc5f7be52d2a1f',
                    type: 'text'
                  },
                  {
                    field: '65d1d3d819c020e78f534d59',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1396,
                    _id: '65d1d3dd94550000d40357e2',
                    type: 'text'
                  },
                  {
                    field: '65d1d40f56cd2d6b9c07c180',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1508,
                    _id: '65d1d413c6cf60428efbe50f',
                    type: 'text'
                  },
                  {
                    field: '65d1d8c80622a530987b72e5',
                    displayType: 'original',
                    width: 1,
                    height: 70,
                    x: 0,
                    y: 1900,
                    _id: '65d1d8d11e600079fba4dacb',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1d434fff6324f1012fdf6',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1564,
                    _id: '65d1d448e2ee2a3de9e624eb',
                    type: 'text'
                  },
                  {
                    field: '65d1d950a0957ed7a50d85d4',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1970,
                    _id: '65d1d965683be6635f1b8ede',
                    type: 'text'
                  },
                  {
                    field: '65d1d46b1d386548a32eb112',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1620,
                    _id: '65d1d4788f49686fc99d5bc4',
                    type: 'text'
                  },
                  {
                    field: '65d1d9980c14c928135beef7',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2026,
                    _id: '65d1da0b887238691983a7ec',
                    type: 'date'
                  },
                  {
                    field: '65d1d4b8040f0d98dfe1851d',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 1676,
                    _id: '65d1d4c052cf73626735b4b2',
                    type: 'text'
                  },
                  {
                    field: '65d1da3234d6d6abfa51cc23',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2082,
                    _id: '65d1da38e999e5af642380a2',
                    type: 'date'
                  },
                  {
                    field: '65d1d500a96bc4230df101a0',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2138,
                    _id: '65d1d506849bcea3e102439f',
                    type: 'text'
                  },
                  {
                    field: '65d1d521c17ec313c7488715',
                    displayType: 'original',
                    width: 1,
                    height: 92,
                    x: 0,
                    y: 2194,
                    _id: '65d1d52e5c23534e4396fb52',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1e10649aecfcd473a47bd',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2474,
                    _id: '65d1e111aaa911101a0cd84c',
                    type: 'text'
                  },
                  {
                    field: '65d1de4af7edec2b545c7384',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2326,
                    _id: '65d1de55d491c4eaa41a60b2',
                    type: 'text'
                  },
                  {
                    field: '65d1de9da3260d4360eb53e7',
                    displayType: 'original',
                    width: 1,
                    height: 92,
                    x: 0,
                    y: 2382,
                    _id: '65d1df8db6551ce5b9a4a9b7',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1e04405d7da535f7d4bc8',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2530,
                    _id: '65d1e04e67e96eab748673c8',
                    type: 'text'
                  },
                  {
                    field: '65d1e099139e32b9bf5c3e31',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2586,
                    _id: '65d1e0e86437468fefdd43e4',
                    type: 'dropdown'
                  },
                  {
                    field: '65d1f43005b59e9ac8c79b55',
                    displayType: 'original',
                    width: 1,
                    height: 69,
                    x: 0,
                    y: 2642,
                    _id: '65d1f4894cfa4a1b5d67b813',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1f4b78c68ced36101cd83',
                    displayType: 'original',
                    width: 1,
                    height: 65,
                    x: 0,
                    y: 2711,
                    _id: '65d1f4c5530a4603c4a94b3b',
                    type: 'text'
                  },
                  {
                    field: '65d1f51cfb37784612a66de1',
                    displayType: 'original',
                    width: 1,
                    height: 66,
                    x: 0,
                    y: 2776,
                    _id: '65d1f525b9a05b6b406caf15',
                    type: 'text'
                  },
                  {
                    field: '65d1f60e0c0013edc89db276',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2938,
                    _id: '65d1f616f7e40fed67981bf2',
                    type: 'text'
                  },
                  {
                    field: '65d1f5bde7289c3fde1ab4cb',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2882,
                    _id: '65d1f5c792181eaa2c65e899',
                    type: 'text'
                  },
                  {
                    field: '65d1f63997f9c5ec5a8ddac7',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 2994,
                    _id: '65d1f6462587ade5d5d6ced6',
                    type: 'text'
                  },
                  {
                    field: '65d1f6672d9010fb33ff0b6d',
                    displayType: 'original',
                    width: 1,
                    height: 92,
                    x: 0,
                    y: 3050,
                    _id: '65d1f6a7f3718407b265713d',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1f73458e8b29662412089',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3142,
                    _id: '65d1f77c2b694e5f8c2fb4d5',
                    type: 'date'
                  },
                  {
                    field: '65d1f83c0600145c640174bf',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3250,
                    _id: '65d1f84883eb7578629ff819',
                    type: 'date'
                  },
                  {
                    field: '65d1f7bfc78de58a2158ac93',
                    displayType: 'original',
                    width: 1,
                    height: 52,
                    x: 0,
                    y: 3198,
                    _id: '65d1f7c661dafb335d3f20fd',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1f873ee3086a86b8dc47e',
                    displayType: 'original',
                    width: 1,
                    height: 53,
                    x: 0,
                    y: 3306,
                    _id: '65d1f8dbbc1d656376dc273d',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1f9050755290ef6a7229f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3359,
                    _id: '65d1f912256a915134b94114',
                    type: 'date'
                  },
                  {
                    field: '65d1f93f701dbf46d408c2f1',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3415,
                    _id: '65d1f94ff8a7b871d3f2334a',
                    type: 'date'
                  },
                  {
                    field: '65d1f977daf78f6b224bff9a',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3471,
                    _id: '65d1f98208a005e8a4d26904',
                    type: 'date'
                  },
                  {
                    field: '65d1f9e6707eb5d28af52021',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3527,
                    _id: '65d1f9f62bbe5c01e99ce528',
                    type: 'date'
                  },
                  {
                    field: '65d1fa21646e1d3d61ca94bb',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3583,
                    _id: '65d1fa29acac3319c75688aa',
                    type: 'text'
                  },
                  {
                    field: '65d1f9aeed0a369a66a4e9d3',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3639,
                    _id: '65d1f9bb3fcf69be49db5e44',
                    type: 'date'
                  },
                  {
                    field: '65d1fa63dd2c5e93a6932222',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3695,
                    _id: '65d1fa7c107857173fefd7c3',
                    type: 'text'
                  },
                  {
                    field: '65d1faa63f2cca70b5f87271',
                    displayType: 'original',
                    width: 1,
                    height: 69,
                    x: 0,
                    y: 3751,
                    _id: '65d1fab0c6bae1c3b5d04fd3',
                    type: 'multiSelect'
                  },
                  {
                    field: '65d1fc533789b1c5d8b89d11',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 3820,
                    _id: '65d1fc5f882334a079f52faa',
                    type: 'text'
                  },
                  {
                    field: '65d1fc8fd78dd086e4f95eaf',
                    displayType: 'original',
                    width: 1,
                    height: 67,
                    x: 0,
                    y: 3876,
                    _id: '65d1fc9e4680ac4c3549a507',
                    type: 'text'
                  },
                  {
                    field: '65d1fcf2a74ee289f74ba4c0',
                    displayType: 'original',
                    width: 1,
                    height: 200,
                    x: 0,
                    y: 3943,
                    _id: '65d1fd0e5758c5540bc9e668',
                    type: 'textarea'
                  },
                  {
                    field: '65d203f65f26f030afb036e9',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4143,
                    _id: '65d203ff99f0f93b930042ac',
                    type: 'dropdown'
                  },
                  {
                    field: '65d202f090d127ede8c4427d',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4199,
                    _id: '65d202fbe6b93bb9165bb5f9',
                    type: 'dropdown'
                  },
                  {
                    field: '65d20478054108a19e043da4',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4255,
                    _id: '65d2048956fc96e788e7b62d',
                    type: 'dropdown'
                  },
                  {
                    field: '65d20512e5462b67bcac816f',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4311,
                    _id: '65d20534ef5e0cdf63d70d52',
                    type: 'dropdown'
                  },
                  {
                    field: '65d2037d57324eba8db5c3b3',
                    displayType: 'original',
                    width: 1,
                    height: 240,
                    x: 0,
                    y: 4367,
                    _id: '65d20398aa24f854db74487a',
                    type: 'textarea'
                  },
                  {
                    field: '65d205c178ee2c1777c19d86',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4607,
                    _id: '65d205d17f56e73a21e5f5c3',
                    type: 'text'
                  },
                  {
                    field: '65d206427f1fe34e3351fb51',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 4703,
                    _id: '65d2064dfcdf171b60ae61d0',
                    type: 'text'
                  },
                  {
                    field: '65d206b092d789d8ac93ed6f',
                    displayType: 'original',
                    width: 1,
                    height: 152,
                    x: 0,
                    y: 4959,
                    _id: '65d206c72852f54b8d3221be',
                    type: 'multiSelect'
                  },
                  {
                    field: '65db36e03a3340e635ebda49',
                    displayType: 'original',
                    width: 1,
                    height: 200,
                    x: 0,
                    y: 4759,
                    _id: '65db36e2b6c4af2e12f1292d',
                    type: 'textarea'
                  },
                  {
                    field: '65d209f3d1aa7990eb7a4b3d',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 5167,
                    _id: '65d209fef66c8d015a78d764',
                    type: 'text'
                  },
                  {
                    field: '65d208f5154127b3a2a07fe2',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 5111,
                    _id: '65d2090e324a76d8ba471ebb',
                    type: 'dropdown'
                  },
                  {
                    field: '65d20a2a14d8bac77f65b244',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 5223,
                    _id: '65d20a38058dc9a8ec6d5cb0',
                    type: 'text'
                  },
                  {
                    field: '65d20a750f0a7e57fc0c0520',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 5279,
                    _id: '65d20a844f7c2d12ed49032c',
                    type: 'text'
                  },
                  {
                    field: '65d20aefa0f671dead87b046',
                    displayType: 'original',
                    width: 1,
                    height: 56,
                    x: 0,
                    y: 5335,
                    _id: '65d20afcf2058b546c8ff976',
                    type: 'date'
                  },
                  {
                    field: '65dbae744df65c799b0574e2',
                    displayType: 'original',
                    width: 1,
                    height: 70,
                    x: 0,
                    y: 0,
                    fontSize: 24,
                    fontWeight: 'bold',
                    _id: '65dbae7b41b99c55430d69dc',
                    type: 'block'
                  },
                  {
                    field: '65dbaec55c899004209580d1',
                    displayType: 'original',
                    width: 1,
                    height: 90,
                    x: 0,
                    y: 70,
                    _id: '65dbaecba2a32bbe81bc198b',
                    type: 'block'
                  },
                  {
                    field: '65dbb045c366f8d235150ae0',
                    displayType: 'original',
                    width: 1,
                    height: 40,
                    x: 0,
                    y: 160,
                    fontSize: 18,
                    fontWeight: 'bold',
                    _id: '65dbb0570445b6f289fdb17d',
                    type: 'block'
                  },
                  {
                    field: '65dbb14fbe8bc8ff04cc17e6',
                    displayType: 'original',
                    width: 1,
                    height: 40,
                    x: 0,
                    y: 1188,
                    fontSize: 18,
                    fontWeight: 'bold',
                    _id: '65dbb15c5002694ffa7b259f',
                    type: 'block'
                  },
                  {
                    field: '65dbb21b72c22817cfce990c',
                    displayType: 'original',
                    width: 1,
                    height: 40,
                    x: 0,
                    y: 2286,
                    fontSize: 18,
                    fontWeight: 'bold',
                    _id: '65dbb22ab1015e09c3ff49d4',
                    type: 'block'
                  },
                  {
                    field: '65dbb2d837277488b2183d8d',
                    displayType: 'original',
                    width: 1,
                    height: 40,
                    x: 0,
                    y: 2842,
                    fontSize: 18,
                    fontWeight: 'bold',
                    _id: '65dbb2e53d0f0cf4b931e989',
                    type: 'block'
                  },
                  {
                    field: '65dbb3da03194f7e6df3abc7',
                    displayType: 'original',
                    width: 1,
                    height: 40,
                    x: 0,
                    y: 4663,
                    fontSize: 18,
                    fontWeight: 'bold',
                    _id: '65dbb3e9c76443aff14ac31f',
                    type: 'block'
                  }
                ],
                metadata: {},
                hidden: false,
                width: 816,
                height: 1056,
                cols: 1,
                rowHeight: 1,
                layout: 'grid',
                presentation: 'normal',
                margin: 0,
                padding: 12,
                borderWidth: 0,
                _id: '65d0e0ba86479093a095ed5f'
              }
            ],
            _id: '65dbae3af5b880001988e536'
          }
        ]
      }
    ],
    fields: [
      {
        type: 'text',
        _id: '65d0e5a4e3b6404bea23d0fd',
        identifier: 'field_65d0e5ab057e5866803f6e42',
        title: 'Employer’s Name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e5f3d10bddbc86484109',
        identifier: 'field_65d0e5fdbece0ed63c9a0fef',
        title: 'Address',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e6223f4331c2f5dffbcb',
        identifier: 'field_65d0e62a799a45223d1881bc',
        title: 'City',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e654a6401c9e7bdd5c8c',
        identifier: 'field_65d0e65ac456b10b7c5d3e65',
        title: 'State',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e67f16c0a099e9f5b5ab',
        identifier: 'field_65d0e68477b7857c70ae0885',
        title: 'Zip',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e6b3c1f1f5ef3301914f',
        identifier: 'field_65d0e6bbc0b858b208a2788d',
        title: 'Phone #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e6e47a9bdaa3c21ef637',
        identifier: 'field_65d0e6fdbee4984e3b00ea95',
        title: 'Fax #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e716ccc237f61a4ba55d',
        identifier: 'field_65d0e71cc474259222d170b6',
        title: 'Employer’s location address (if different)',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e76e60a5efebd27663ed',
        identifier: 'field_65d0e782bbe76f9ceaf5256e',
        title: 'Address',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e79ce619f705df0066f5',
        identifier: 'field_65d0e7a29421183d6d83f0d7',
        title: 'City',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e7c54be4757982f61298',
        identifier: 'field_65d0e7ca027994baef489a12',
        title: 'State',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e7e647ca425a1a913307',
        identifier: 'field_65d0e7eb929815bb6e9d5f57',
        title: 'Zip',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0e8184d0073cfa384ac80',
        identifier: 'field_65d0e81fa80a79c92a3bb843',
        title: 'Policy Number',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d0e842d603cdcca008c6a6',
        identifier: 'field_65d0e858faacf0b2471d5114',
        title: 'Employer Status',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          {
            _id: '65d0def9fb2704aa0fef7931',
            value: 'Sole Proprietor',
            deleted: false
          },
          { _id: '65d0def9c4a0d47ddd10115a', value: 'LLC', deleted: false },
          { _id: '65d0def99cd72dbdb88f902a', value: 'Public', deleted: false },
          {
            _id: '65d0e8db2bd27bdd43afc8ba',
            value: 'Partnership',
            width: 200,
            deleted: false
          },
          {
            _id: '65d0e8eb5f6f875511704754',
            value: 'Corporation',
            width: 200,
            deleted: false
          },
          {
            _id: '65d0e8f759ea630bf7f7cb3b',
            value: 'Other',
            width: 200,
            deleted: false
          }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d0ea34a92b89fad0b4260f',
        identifier: 'field_65d0ea40dbdf258adbcaf8f9',
        title:
          'Is injured worker a corporate officer, partner, LLC member or sole proprietor?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d0def90ecc49473781afa2', value: 'Yes', deleted: false },
          { _id: '65d0def98546059c5e2c5569', value: 'No', deleted: false },
          { _id: '65d0def95016d07145723140', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d0f3816eb10dda55b73fed',
        identifier: 'field_65d0f3915f4a5d9372c36959',
        title:
          'If a sole proprietorship or LLC, is the injured worker a household member?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d0def90ecc49473781afa2', value: 'Yes', deleted: false },
          { _id: '65d0def98546059c5e2c5569', value: 'No', deleted: false },
          { _id: '65d0def95016d07145723140', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d0f4f4c75da8f37acbabe8',
        identifier: 'field_65d0f50716036d64fc62162b',
        title: 'Organization Code',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d3384298244323051661',
        identifier: 'field_65d1d347abead6e0d52c6d78',
        title: 'Employee’s last name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d37179acabe8a8a48985',
        identifier: 'field_65d1d37ce83923f996f1b0d6',
        title: 'Employee’s first name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d3a3ee3eef6ac45c45a3',
        identifier: 'field_65d1d3aefc9373fa712d84ae',
        title: 'Address',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d3d819c020e78f534d59',
        identifier: 'field_65d1d3ddfc3a00385228fd61',
        title: 'City',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d3f3158f7ec1e8b6bbbc',
        identifier: 'field_65d1d3f878c94369774b66af',
        title: 'State',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d40f56cd2d6b9c07c180',
        identifier: 'field_65d1d413c932229ed402d3b5',
        title: 'Zip',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d434fff6324f1012fdf6',
        identifier: 'field_65d1d4480d0674f89ebde340',
        title: 'Phone #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d46b1d386548a32eb112',
        identifier: 'field_65d1d4784804003b18deb031',
        title: 'Date of Birth',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d4b8040f0d98dfe1851d',
        identifier: 'field_65d1d4c0dbdb50f4e7525f46',
        title: 'Under what class code were wages reported?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d500a96bc4230df101a0',
        identifier: 'field_65d1d506b7f0b5a5348b41d9',
        title: 'Regular Department',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1d521c17ec313c7488715',
        identifier: 'field_65d1d52ec29a6bfcb7eece98',
        title: 'Marital Status',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d0faf0021ff927262b3ec4', value: 'Yes', deleted: true },
          { _id: '65d0faf03b02129b7310c072', value: 'Single', deleted: false },
          { _id: '65d0faf035a07cda62689d12', value: 'Widowed', deleted: false },
          {
            _id: '65d1d5eac6755fdd5b5fc342',
            value: 'Other',
            width: 200,
            deleted: false
          },
          {
            _id: '65d1d5fc5af06a92ab00c833',
            value: 'Married',
            width: 200,
            deleted: false
          },
          {
            _id: '65d1d609ab3aa86d4d802a68',
            value: 'Separated',
            width: 200,
            deleted: false
          }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d7f56aabcba35e031b48',
        identifier: 'field_65d1d7fcdbba294d0bae7916',
        title: 'State where hired',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d82138efdfc80778a868',
        identifier: 'field_65d1d82797ca86402cf04e75',
        title: 'Occupation',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d875a650de8f7e284b41',
        identifier: 'field_65d1d87bf1d4e4d32f4db8b7',
        title: 'Employment status',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1d8c80622a530987b72e5',
        identifier: 'field_65d1d8d1a34c865eef0721bb',
        title: 'Sex',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d0faf0021ff927262b3ec4', value: 'Female', deleted: false },
          { _id: '65d0faf03b02129b7310c072', value: 'Male', deleted: false },
          { _id: '65d0faf035a07cda62689d12', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1d950a0957ed7a50d85d4',
        identifier: 'field_65d1d9651b3415b3389b485c',
        title: 'Social Security #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1d9980c14c928135beef7',
        identifier: 'field_65d1da0b3dfd3d1eeb247bbf',
        title: 'Date hired',
        description: '',
        value: 1708808400000,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1da3234d6d6abfa51cc23',
        identifier: 'field_65d1da38d5b666865ed57b68',
        title: 'Injury date',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1de4af7edec2b545c7384',
        identifier: 'field_65d1de55cf79e00dbfb51bc6',
        title: 'Wage rate $',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1de9da3260d4360eb53e7',
        identifier: 'field_65d1deacde0957ced5160f7c',
        title: 'Per',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1dc69cec511656b749c1a', value: 'Hour', deleted: false },
          { _id: '65d1dc69167aebe49de54148', value: 'Day', deleted: false },
          { _id: '65d1dc698b768647e1fbb992', value: 'Week', deleted: false },
          {
            _id: '65d1df4cadf39ae694af0ee6',
            value: 'Month',
            width: 200,
            deleted: false
          },
          {
            _id: '65d1df5fc3aa3376d9a25041',
            value: 'Other',
            width: 200,
            deleted: false
          }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1e04405d7da535f7d4bc8',
        identifier: 'field_65d1e04eb827df64252f26f9',
        title: '# of days worked per week',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d1e099139e32b9bf5c3e31',
        identifier: 'field_65d1e0a5883b8799ee49b95b',
        title: 'Full pay for the day of injury?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1dc69d3604a218522469e', value: 'Yes', deleted: false },
          { _id: '65d1dc698ce3884bf86649c4', value: 'No', deleted: false },
          { _id: '65d1dc69ff6fe50225143a91', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1e10649aecfcd473a47bd',
        identifier: 'field_65d1e111c525ba9fa4243eb9',
        title: 'Hours worked per week',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1f43005b59e9ac8c79b55',
        identifier: 'field_65d1f44172034983829c8c16',
        title: 'Did salary continue?',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d51237462cdf89b3d6', value: 'Yes', deleted: false },
          { _id: '65d1e1d544f817a1374f24fd', value: 'No', deleted: false },
          { _id: '65d1e1d52534c77231913602', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1f4b78c68ced36101cd83',
        identifier: 'field_65d1f4c516dcbd7a2a0904c1',
        title:
          'If board, lodging or other advantages furnished in addition to wages, give estimated value per week $',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1f51cfb37784612a66de1',
        identifier: 'field_65d1f525bc0b73c079f46ec9',
        title:
          'If gratitudes (tips, etc.) were received in the course of employment, give estimated value per week $',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1f5bde7289c3fde1ab4cb',
        identifier: 'field_65d1f5c77e74fb09241ab8f5',
        title: 'Place of accident or exposure (address)',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1f60e0c0013edc89db276',
        identifier: 'field_65d1f616cc57f9e191136b48',
        title: 'City/State',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1f63997f9c5ec5a8ddac7',
        identifier: 'field_65d1f6469ac0f376ab715a97',
        title: 'County',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1f6672d9010fb33ff0b6d',
        identifier: 'field_65d1f6a716fb32d0c4ef04e6',
        title: 'Did injury/illness occur on the employer’s premises?',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d51237462cdf89b3d6', value: 'Yes', deleted: false },
          { _id: '65d1e1d544f817a1374f24fd', value: 'No', deleted: false },
          { _id: '65d1e1d52534c77231913602', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f73458e8b29662412089',
        identifier: 'field_65d1f77c0d31f64d881ad35e',
        title: 'Time injury occurred',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1f7bfc78de58a2158ac93',
        identifier: 'field_65d1f7c6d3952e2939cdb616',
        title: '',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d51237462cdf89b3d6', value: 'AM', deleted: false },
          { _id: '65d1e1d544f817a1374f24fd', value: 'PM', deleted: false },
          { _id: '65d1e1d52534c77231913602', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f83c0600145c640174bf',
        identifier: 'field_65d1f848180480cb001fa6fd',
        title: 'Time employee began work',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1f873ee3086a86b8dc47e',
        identifier: 'field_65d1f88a58f7be6b8f4295aa',
        title: '',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d51237462cdf89b3d6', value: 'AM', deleted: false },
          { _id: '65d1e1d544f817a1374f24fd', value: 'PM', deleted: false },
          { _id: '65d1e1d52534c77231913602', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f9050755290ef6a7229f',
        identifier: 'field_65d1f912b5acefe8c34edb5a',
        title: 'Date last worked',
        description: '',
        value: 1708808400000,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f93f701dbf46d408c2f1',
        identifier: 'field_65d1f94fa917e9d8451c7ab4',
        title: 'Date employer notified',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f977daf78f6b224bff9a',
        identifier: 'field_65d1f98297538f7b2ee328a4',
        title: 'Date disability began',
        description: '',
        value: 1708808400000,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f9aeed0a369a66a4e9d3',
        identifier: 'field_65d1f9bb4d201d9082a78fee',
        title: 'Date returned to work',
        description: '',
        value: 1708808400000,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d1f9e6707eb5d28af52021',
        identifier: 'field_65d1f9f6f21ecddb2ff92f4b',
        title: 'If fatal, date of death',
        description: '',
        value: null,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1fa21646e1d3d61ca94bb',
        identifier: 'field_65d1fa29aa84b08ae8ce9320',
        title: 'Injury type (strain, cut, etc.)',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1fa63dd2c5e93a6932222',
        identifier: 'field_65d1fa7c9615b73f8808586a',
        title: 'Part of body affected',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d1faa63f2cca70b5f87271',
        identifier: 'field_65d1fab08c9b5445b4ec9849',
        title: 'Body part injured before?',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d51237462cdf89b3d6', value: 'Yes', deleted: false },
          { _id: '65d1e1d544f817a1374f24fd', value: 'No', deleted: false },
          { _id: '65d1e1d52534c77231913602', value: 'N/A', deleted: true }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1fc533789b1c5d8b89d11',
        identifier: 'field_65d1fc5f625a941fe075a294',
        title: 'Injury reported to (name and phone #)',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d1fc8fd78dd086e4f95eaf',
        identifier: 'field_65d1fc9e29b7b45e35e802dc',
        title:
          'Equipment, materials, or chemicals employee was using upon occurrence',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'textarea',
        _id: '65d1fcf2a74ee289f74ba4c0',
        identifier: 'field_65d1fd0e384bdaf102a90e2f',
        title:
          'How injury or illness occurred (Describe the sequence of events. Include objects or substances that directly caused the injury)',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d202f090d127ede8c4427d',
        identifier: 'field_65d202fbbab01cbb6b983726',
        title: 'Was accident caused by the failure of a machine or product?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d56763e46a1602ba45', value: 'Yes', deleted: false },
          { _id: '65d1e1d58dbc9af825cf162c', value: 'No', deleted: false },
          { _id: '65d1e1d59127e9e2c1935b5a', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'textarea',
        _id: '65d2037d57324eba8db5c3b3',
        identifier: 'field_65d203981ec4b75ae5ec4139',
        title:
          'If the accident was caused by any person or business other than the injured worker, co-worker or the employer, please identify.',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d203f65f26f030afb036e9',
        identifier: 'field_65d203ff53571803e756028e',
        title: 'Was safety equipment provided?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d56763e46a1602ba45', value: 'Yes', deleted: false },
          { _id: '65d1e1d58dbc9af825cf162c', value: 'No', deleted: false },
          { _id: '65d1e1d59127e9e2c1935b5a', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d20478054108a19e043da4',
        identifier: 'field_65d20489e3bf89248664baeb',
        title: 'Was it used?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d56763e46a1602ba45', value: 'Yes', deleted: false },
          { _id: '65d1e1d58dbc9af825cf162c', value: 'No', deleted: false },
          { _id: '65d1e1d59127e9e2c1935b5a', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d20512e5462b67bcac816f',
        identifier: 'field_65d20534e1b6a97a7f1c7808',
        title: 'Were other workers also injured?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d56763e46a1602ba45', value: 'Yes', deleted: false },
          { _id: '65d1e1d58dbc9af825cf162c', value: 'No', deleted: false },
          { _id: '65d1e1d59127e9e2c1935b5a', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d205c178ee2c1777c19d86',
        identifier: 'field_65d205d11fa12262250c6032',
        title: 'List other workers’ names',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d206427f1fe34e3351fb51',
        identifier: 'field_65d2064dfc010bd81df02ed4',
        title: 'Physician or hospital name',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'multiSelect',
        _id: '65d206b092d789d8ac93ed6f',
        identifier: 'field_65d206c7270735652f29fa5b',
        title: '',
        description: '',
        value: [],
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          {
            _id: '65d1e1d51237462cdf89b3d6',
            value: 'No medical treatment',
            deleted: false
          },
          {
            _id: '65d1e1d544f817a1374f24fd',
            value: 'Minor - clinic/hospital',
            deleted: false
          },
          {
            _id: '65d1e1d52534c77231913602',
            value: 'Anticipated major med/time loss',
            deleted: false
          },
          {
            _id: '65d207744e091f9cda5bf8a6',
            value: 'Minor by employer',
            width: 200,
            deleted: false
          },
          {
            _id: '65d2078d302ba1342df82a6b',
            value: 'Emergency care',
            width: 200,
            deleted: false
          },
          {
            _id: '65d207ac9a5ed91fff1ab88f',
            value: 'Hospitalized overnight',
            width: 200,
            deleted: false
          }
        ],
        multi: false,
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'dropdown',
        _id: '65d208f5154127b3a2a07fe2',
        identifier: 'field_65d2090e2925141ddd2ae90e',
        title: 'Did anyone witness the accident?',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        options: [
          { _id: '65d1e1d56763e46a1602ba45', value: 'Yes', deleted: false },
          { _id: '65d1e1d58dbc9af825cf162c', value: 'No', deleted: false },
          { _id: '65d1e1d59127e9e2c1935b5a', value: 'N/A', deleted: true }
        ],
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d209f3d1aa7990eb7a4b3d',
        identifier: 'field_65d209fe000ea1016de3dabe',
        title: 'If yes, provide name and phone #',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d20a2a14d8bac77f65b244',
        identifier: 'field_65d20a3894554309429bded5',
        title: 'Preparer’s name and title',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'text',
        _id: '65d20a750f0a7e57fc0c0520',
        identifier: 'field_65d20a84f818ad21ea757d1c',
        title: 'Preparer’s Phone Number',
        description: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'date',
        _id: '65d20aefa0f671dead87b046',
        identifier: 'field_65d20afc131d83a7d2316b8e',
        title: 'Date Prepared',
        description: '',
        value: 1708808400000,
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'textarea',
        _id: '65db36e03a3340e635ebda49',
        identifier: 'field_65db36e2a0726024cc8afd2d',
        title: 'Physician or hospital address',
        description: '',
        value: '',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbae744df65c799b0574e2',
        identifier: 'field_65dbae7bcc291c223f21bff2',
        title: 'Display Text',
        description: '',
        value: 'Workers Compensation - First Report of Injury or Illness',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbaec55c899004209580d1',
        identifier: 'field_65dbaecb23a3796515da7a1f',
        title: 'Display Text',
        description: '',
        value:
          'Every work injury that requires medical treatment other than first aid treatment must be reported within ten days after the employer has the knowledge of the injury. Filing this form is not an admission of liability. This report shall not be evidence of any fact stated herein in any proceeding in respect of the injury, illness or death on account of which this report is made.',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbb045c366f8d235150ae0',
        identifier: 'field_65dbb057700bbd036778e007',
        title: 'Display Text',
        description: '',
        value: 'Employer',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbb14fbe8bc8ff04cc17e6',
        identifier: 'field_65dbb15c1fd3143e2186b380',
        title: 'Display Text',
        description: '',
        value: 'Employee',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbb21b72c22817cfce990c',
        identifier: 'field_65dbb22a355204c42b7ca942',
        title: 'Display Text',
        description: '',
        value: 'Wages',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbb2d837277488b2183d8d',
        identifier: 'field_65dbb2e5c83cb303a5849eb5',
        title: 'Display Text',
        description: '',
        value: 'Accident or Illness',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      },
      {
        type: 'block',
        _id: '65dbb3da03194f7e6df3abc7',
        identifier: 'field_65dbb3e98df184101027a465',
        title: 'Display Text',
        description: '',
        value: 'MED',
        required: false,
        tipTitle: '',
        tipDescription: '',
        tipVisible: false,
        metadata: {},
        file: '65d0e0ba32859807c91f3d4a'
      }
    ],
    deleted: false,
    categories: []
  }
};
